(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2569],{

/***/ 55005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ CallButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/contexts/Global/index.js + 5 modules
var Global = __webpack_require__(25330);
;// CONCATENATED MODULE: ./src/components/CallButton/CallButton.jsx



var CallButton = function(param) {
    var _noTitle = param.noTitle, noTitle = _noTitle === void 0 ? false : _noTitle, theme = param.theme, hover = param.hover;
    var phoneNumber = (0,Global/* useGlobalState */.j1)().phoneNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
        as: "a",
        htmlAttributes: {
            href: "tel:".concat(phoneNumber)
        },
        icon: "tel",
        theme: theme,
        hover: hover,
        appearance: "outlined",
        children: !noTitle ? phoneNumber : null
    });
};

;// CONCATENATED MODULE: ./src/components/CallButton/index.js



/***/ }),

/***/ 51712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ Footer; },
  "b": function() { return /* reexport */ FooterWidgetWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/CallButton/index.js + 1 modules
var CallButton = __webpack_require__(55005);
// EXTERNAL MODULE: ./src/components/LanguageSelector/index.js + 5 modules
var LanguageSelector = __webpack_require__(3319);
// EXTERNAL MODULE: ./src/components/SocialSharing/index.js + 5 modules
var SocialSharing = __webpack_require__(96352);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/components/SiteLogo/index.js + 1 modules
var SiteLogo = __webpack_require__(21472);
// EXTERNAL MODULE: ./src/shared/components/Typography/index.js + 19 modules
var Typography = __webpack_require__(6271);
// EXTERNAL MODULE: ./src/shared/contexts/Menus/index.js + 4 modules
var Menus = __webpack_require__(37013);
// EXTERNAL MODULE: ./src/components/Footer/FooterDesktop/FooterDesktop.module.scss
var FooterDesktop_module = __webpack_require__(45139);
var FooterDesktop_module_default = /*#__PURE__*/__webpack_require__.n(FooterDesktop_module);
;// CONCATENATED MODULE: ./src/components/Footer/FooterDesktop/FooterDesktop.jsx











var FooterDesktop = function(param) {
    var year = param.year;
    var t = (0,translations/* useTranslation */.$)().t;
    var footerData = (0,Menus/* useMenusState */.iR)().footerData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (FooterDesktop_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
                className: classnames_default()((FooterDesktop_module_default()).row, (FooterDesktop_module_default()).links),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FooterDesktop_module_default()).col,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteLogo/* SiteLogo */.S, {
                            type: "footer"
                        })
                    }),
                    footerData.map(function(param) {
                        var id = param.id, title = param.title, items = param.items;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: (FooterDesktop_module_default()).col,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (FooterDesktop_module_default()).selector,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (FooterDesktop_module_default()).title,
                                        children: t(title)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                        className: (FooterDesktop_module_default()).list,
                                        children: items === null || items === void 0 ? void 0 : items.map(function(param) {
                                            var title = param.title, url = param.url, target = param.target;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                                                link: url,
                                                target: target,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                    className: (FooterDesktop_module_default()).item,
                                                    appearance: "smaller",
                                                    uppercase: true,
                                                    children: title
                                                })
                                            }, title);
                                        })
                                    })
                                ]
                            })
                        }, id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
                className: classnames_default()((FooterDesktop_module_default()).row, (FooterDesktop_module_default()).info),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FooterDesktop_module_default()).col,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                            appearance: "smaller",
                            color: "light",
                            className: (FooterDesktop_module_default()).label,
                            children: [
                                "\xa9 ",
                                year,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                t("All rights reserved")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FooterDesktop_module_default()).col,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallButton/* CallButton */.H, {
                            theme: "light",
                            hover: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FooterDesktop_module_default()).col,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialSharing/* SocialSharing */.e, {
                            inline: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterDesktop_module_default()).col,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* MenuItem */.sN, {
                                className: (FooterDesktop_module_default()).label,
                                color: "light",
                                children: t("Lang/Мова")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelector/* LanguageSelector */.$, {
                                appearance: "light",
                                inline: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterDesktop_module_default()).col,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* MenuItem */.sN, {
                                className: (FooterDesktop_module_default()).label,
                                color: "light",
                                children: t("Desing and development")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                appearance: "bold",
                                color: "light",
                                uppercase: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.lazarev.agency/",
                                        children: "LAZAREV."
                                    }),
                                    " &",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://aurocraft.com/ua",
                                        children: "AUROCRAFT"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Footer/FooterDesktop/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/components/Footer/FooterMobile/FooterMobile.module.scss
var FooterMobile_module = __webpack_require__(94968);
var FooterMobile_module_default = /*#__PURE__*/__webpack_require__.n(FooterMobile_module);
;// CONCATENATED MODULE: ./src/components/Footer/FooterMobile/FooterMobile.jsx













var FooterMobile = function(param) {
    var year = param.year;
    var t = (0,translations/* useTranslation */.$)().t;
    var footerData = (0,Menus/* useMenusState */.iR)().footerData;
    var ref = (0,react.useState)(null), open = ref[0], setOpen = ref[1];
    var onToggle = (0,react.useCallback)(function(title) {
        return function() {
            setOpen(function(current) {
                return current === title ? null : title;
            });
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (FooterMobile_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                className: (FooterMobile_module_default())["links-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FooterMobile_module_default()).links,
                    children: footerData.map(function(param) {
                        var id = param.id, title = param.title, items = param.items;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: onToggle(title),
                            className: (FooterMobile_module_default()).interactive,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((FooterMobile_module_default()).title, (0,_define_property/* default */.Z)({}, (FooterMobile_module_default()).opened, open === title)),
                                    children: [
                                        t(title),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            name: "chevron_down",
                                            theme: "white",
                                            className: (FooterMobile_module_default()).icon
                                        })
                                    ]
                                }),
                                open === title && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    className: (FooterMobile_module_default()).list,
                                    children: items.map(function(param) {
                                        var title = param.title, url = param.url, target = param.target;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                                            link: url,
                                            target: target,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                className: (FooterMobile_module_default()).item,
                                                appearance: "smaller",
                                                uppercase: true,
                                                children: title
                                            })
                                        }, title);
                                    })
                                })
                            ]
                        }, id);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
                className: (FooterMobile_module_default())["social-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CallButton/* CallButton */.H, {
                        theme: "light",
                        hover: "fill"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialSharing/* SocialSharing */.e, {
                        inline: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
                className: (FooterMobile_module_default()).info,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FooterMobile_module_default()).logo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteLogo/* SiteLogo */.S, {
                            type: "footer"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                appearance: "smaller",
                                color: "light",
                                className: (FooterMobile_module_default()).label,
                                children: [
                                    "\xa9 ",
                                    year,
                                    " ",
                                    t("All rights reserved")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                appearance: "smaller",
                                color: "light",
                                className: (FooterMobile_module_default()).label,
                                children: t("International institute of management (MIM-Kyiv)")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
                className: (FooterMobile_module_default()).credentials,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterMobile_module_default()).left,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* MenuItem */.sN, {
                                className: (FooterMobile_module_default()).label,
                                color: "light",
                                children: t("Desing and development")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (FooterMobile_module_default()).brands,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                                        link: "https://www.lazarev.agency/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                            appearance: "bold",
                                            color: "light",
                                            uppercase: true,
                                            children: "LAZAREV."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                        className: (FooterMobile_module_default()).ampersand,
                                        appearance: "bold",
                                        color: "light",
                                        children: "&"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                                        link: "https://aurocraft.com/ua",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                            appearance: "bold",
                                            color: "light",
                                            uppercase: true,
                                            children: "AUROCRAFT"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterMobile_module_default()).right,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* MenuItem */.sN, {
                                className: (FooterMobile_module_default()).label,
                                color: "light",
                                children: t("Lang/Мова")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelector/* LanguageSelector */.$, {
                                appearance: "light",
                                inline: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Footer/FooterMobile/index.js


// EXTERNAL MODULE: ./src/components/WidgetsRenderer/index.js + 94 modules
var WidgetsRenderer = __webpack_require__(28986);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
;// CONCATENATED MODULE: ./src/components/Footer/FooterWidgets/FooterWidgets.jsx



var FooterWidgets = function() {
    var footer = (0,PageData/* usePageData */.Vi)().footer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetsRenderer/* WidgetsRenderer */.a, {
        registry: "footer",
        items: footer
    });
};

;// CONCATENATED MODULE: ./src/components/Footer/FooterWidgets/index.js


;// CONCATENATED MODULE: ./src/components/Footer/Footer.jsx






var Footer = function() {
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var currentYear = (0,react.useMemo)(function() {
        return new Date().getFullYear();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWidgets, {}),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterDesktop, {
                year: currentYear
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMobile, {
                year: currentYear
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Footer/FooterWidgetWrapper/FooterWidgetWrapper.module.scss
var FooterWidgetWrapper_module = __webpack_require__(81739);
var FooterWidgetWrapper_module_default = /*#__PURE__*/__webpack_require__.n(FooterWidgetWrapper_module);
;// CONCATENATED MODULE: ./src/components/Footer/FooterWidgetWrapper/FooterWidgetWrapper.jsx




// fill: light, grey
var FooterWidgetWrapper = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((FooterWidgetWrapper_module_default()).wrapper, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            children: children
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Footer/FooterWidgetWrapper/index.js


;// CONCATENATED MODULE: ./src/components/Footer/index.js




/***/ }),

/***/ 93590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l0": function() { return /* reexport */ FormType; },
  "fb": function() { return /* reexport */ FormContent; },
  "Nf": function() { return /* reexport */ FormInfo; }
});

// UNUSED EXPORTS: FormApplication, FormRegistration, FormSubscription, validate

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
;// CONCATENATED MODULE: ./src/components/Forms/validate.js




var validators = {
    required: function(value) {
        return Boolean(value);
    },
    pattern: function(value, regex) {
        return new RegExp(regex).test(value);
    }
};
var validate = function(data, config) {
    return config.reduce(function(errorsAcc, param) {
        var name = param.name, validator = param.validator;
        var fieldValue = data[name];
        var fieldErrors = validateOne(name, fieldValue, validator);
        return (0,_object_spread/* default */.Z)({}, errorsAcc, fieldErrors);
    }, {});
};
var validateOne = function(nameOne, dataOne, configOne) {
    var validatorsEntries = Object.entries(configOne);
    var fieldErrors = validatorsEntries.reduce(function(acc, param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), validatorKey = _param[0], validatorValue = _param[1];
        var result = validators[validatorKey](dataOne, validatorValue);
        if (!result) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, validatorKey, true));
        }
        return acc;
    }, {});
    if (Object.keys(fieldErrors).length > 0) {
        return (0,_define_property/* default */.Z)({}, nameOne, fieldErrors);
    }
    return (0,_define_property/* default */.Z)({}, nameOne, null);
};

;// CONCATENATED MODULE: ./src/components/Forms/useForm.js






var useForm = function(param) {
    var fields = param.fields;
    var initialValues = (0,react.useMemo)(function() {
        return fields.reduce(function(acc, param) {
            var name = param.name, defaultValue = param.defaultValue;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, name, defaultValue));
        }, {});
    }, [
        fields
    ]);
    var ref = (0,react.useState)(initialValues), formInfo = ref[0], setFormInfo = ref[1];
    var ref1 = (0,react.useState)({}), errors = ref1[0], setErrors = ref1[1];
    var ref2 = (0,react.useState)(false), submitReady = ref2[0], setSubmitReady = ref2[1];
    var onChange = (0,react.useCallback)(function(e) {
        setFormInfo(function(currentFormInfo) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentFormInfo), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value));
        });
    }, []);
    var onValidate = (0,react.useCallback)(function(e) {
        var fieldName = e.target.name;
        var fieldValue = formInfo[e.target.name];
        var ref = (0,_sliced_to_array/* default */.Z)(fields.filter(function(param) {
            var name = param.name;
            return name === e.target.name;
        }), 1), fieldConfig = ref[0];
        var validationErrors = validateOne(fieldName, fieldValue, fieldConfig.validator);
        setErrors(function(errors) {
            return (0,_object_spread/* default */.Z)({}, errors, validationErrors);
        });
    }, [
        fields,
        formInfo
    ]);
    var onHandle = (0,react.useCallback)(function() {
        var validateErrors = validate(formInfo, fields);
        setErrors(function(errors) {
            return (0,_object_spread/* default */.Z)({}, errors, validateErrors);
        });
        if (Object.values(validateErrors).filter(Boolean).length > 0) {
            setSubmitReady(false);
        } else {
            setSubmitReady(true);
        }
    }, [
        fields,
        formInfo
    ]);
    var onResetFormHandler = (0,react.useCallback)(function() {
        setFormInfo(function(prevValues) {
            return initialValues;
        });
        setSubmitReady(false);
    }, [
        initialValues
    ]);
    var getInputValue = (0,react.useCallback)(function(name) {
        return formInfo[name];
    }, [
        formInfo
    ]);
    var getInputError = (0,react.useCallback)(function(name) {
        return errors[name];
    }, [
        errors
    ]);
    return {
        formInfo: formInfo,
        errors: errors,
        canBeSubmitted: submitReady,
        getInputValue: getInputValue,
        getInputError: getInputError,
        setErrors: setErrors,
        onChange: onChange,
        onValidate: onValidate,
        onResetFormHandler: onResetFormHandler,
        onHandle: onHandle
    };
};

;// CONCATENATED MODULE: ./src/components/Forms/Form.Provider.js




var FormContent = /*#__PURE__*/ (0,react.createContext)({});
var FormProvider = function(param) {
    var children = param.children, formData = param.formData, type = param.type, metaData = param.metaData, onResetCallback = param.onResetCallback;
    var title = formData.title, fields = formData.fields, buttonText = formData.buttonText, statusErrorText = formData.statusErrorText, statusSuccessfulText = formData.statusSuccessfulText;
    var ref = (0,hooks/* useFormSubmit */.Zf)(formData), error = ref.error, success = ref.success, pending = ref.pending, onResetFormSubmit = ref.onResetFormSubmit, onSubmit = ref.onSubmit;
    var ref1 = useForm({
        fields: fields
    }), formInfo = ref1.formInfo, errors = ref1.errors, canBeSubmitted = ref1.canBeSubmitted, onChange = ref1.onChange, onResetFormHandler = ref1.onResetFormHandler, onValidate = ref1.onValidate, onHandle = ref1.onHandle, getInputValue = ref1.getInputValue, getInputError = ref1.getInputError;
    var onResetForm = (0,react.useCallback)(function() {
        onResetFormHandler();
        onResetFormSubmit();
        if (typeof onResetCallback === "function") {
            onResetCallback();
        }
    }, [
        onResetFormHandler,
        onResetFormSubmit,
        onResetCallback
    ]);
    var value = {
        type: type,
        title: title,
        data: formInfo,
        metaData: metaData,
        buttonText: buttonText,
        statusErrorText: statusErrorText,
        statusSuccessfulText: statusSuccessfulText,
        fields: fields,
        errors: errors,
        canBeSubmitted: canBeSubmitted,
        error: error,
        success: success,
        pending: pending,
        onSubmit: onSubmit,
        onChange: onChange,
        onValidate: onValidate,
        onHandle: onHandle,
        onResetForm: onResetForm,
        getInputValue: getInputValue,
        getInputError: getInputError
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContent.Provider, {
        value: value,
        children: children
    });
};

// EXTERNAL MODULE: ./src/features/logger/logger.utils.js
var logger_utils = __webpack_require__(88953);
;// CONCATENATED MODULE: ./src/features/dataLayer/index.js


var dataLayerEvent = function(formType) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (true) {
        try {
            var ref;
            window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push((0,_object_spread/* default */.Z)({
                event: "form_success",
                form_type: formType
            }, options));
        } catch (error) {
            (0,logger_utils/* logError */.H)(error, "Failed push event to dataLayer");
        }
    }
};

// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/StatusPopup/StatusPopup.module.scss
var StatusPopup_module = __webpack_require__(79694);
var StatusPopup_module_default = /*#__PURE__*/__webpack_require__.n(StatusPopup_module);
;// CONCATENATED MODULE: ./src/components/StatusPopup/StatusPopup.jsx





var StatusPopup = function(param) {
    var status = param.status, className = param.className;
    var t = (0,translations/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((StatusPopup_module_default()).wrapper, (StatusPopup_module_default())[className]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (StatusPopup_module_default()).blocks,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                    color: "dark",
                    className: (StatusPopup_module_default()).title,
                    children: t(status)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StatusPopup_module_default()).circles,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (StatusPopup_module_default()).circle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                            name: className === "successful" ? "done" : " close",
                            className: (StatusPopup_module_default()).icon
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/StatusPopup/index.js


;// CONCATENATED MODULE: ./src/components/Forms/FormSubmitStatus/FormSubmitStatus.jsx





var FormSubmitStatus = function() {
    var ref = (0,react.useContext)(FormContent), success = ref.success, error = ref.error, statusErrorText = ref.statusErrorText, statusSuccessfulText = ref.statusSuccessfulText, onResetForm = ref.onResetForm;
    var handleClose = function() {
        onResetForm();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            success && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalWrapper */.AB, {
                onCloseModal: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusPopup, {
                    status: statusSuccessfulText,
                    className: "successful"
                })
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalWrapper */.AB, {
                onCloseModal: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusPopup, {
                    status: statusErrorText,
                    className: "error"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Forms/FormSubmitStatus/index.js


// EXTERNAL MODULE: ./src/components/Forms/FormApplication/FormApplication.module.scss
var FormApplication_module = __webpack_require__(61526);
var FormApplication_module_default = /*#__PURE__*/__webpack_require__.n(FormApplication_module);
;// CONCATENATED MODULE: ./src/components/Forms/FormApplication/FormApplication.jsx









var FormApplication = function() {
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useContext)(FormContent), data = ref.data, type = ref.type, buttonText = ref.buttonText, fields = ref.fields, canBeSubmitted = ref.canBeSubmitted, metaData = ref.metaData, pending = ref.pending, onHandle = ref.onHandle, onSubmit = ref.onSubmit;
    (0,react.useEffect)(function() {
        if (canBeSubmitted) {
            onSubmit({
                type: type,
                data: data,
                metaData: metaData
            });
            dataLayerEvent("application", {
                email: data === null || data === void 0 ? void 0 : data.email,
                phone: data === null || data === void 0 ? void 0 : data.phone
            });
        }
    }, [
        canBeSubmitted,
        data,
        metaData,
        onSubmit,
        type
    ]);
    var handleSubmit = function(e) {
        e.preventDefault();
        onHandle();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FormApplication_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FormApplication_module_default()).application,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (FormApplication_module_default()).form,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (FormApplication_module_default())["input-group"],
                                children: [
                                    fields.map(function(input) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* InputType */.n$, (0,_object_spread/* default */.Z)({}, input), input.id);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Action */.aU, {
                                        className: (FormApplication_module_default()).submit,
                                        disabled: pending,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                color: "brand",
                                                appearance: "bold",
                                                children: t(buttonText)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (FormApplication_module_default()).arrow,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                    className: (FormApplication_module_default()).icon,
                                                    name: "arrow_right"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSubmitStatus, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Forms/FormApplication/index.js


// EXTERNAL MODULE: ./src/components/Forms/FormInfo/FormInfo.module.scss
var FormInfo_module = __webpack_require__(27754);
var FormInfo_module_default = /*#__PURE__*/__webpack_require__.n(FormInfo_module);
;// CONCATENATED MODULE: ./src/components/Forms/FormInfo/FormInfo.jsx




var FormInfo = function(param) {
    var title = param.title, date = param.date;
    var t = (0,translations/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FormInfo_module_default()).info,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FormInfo_module_default()).item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (FormInfo_module_default())["info-label"],
                        color: "grey",
                        uppercase: true,
                        children: t("title_event")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (FormInfo_module_default())["info-text"],
                        color: "dark",
                        appearance: "bold",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FormInfo_module_default()).item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (FormInfo_module_default())["info-label"],
                        color: "grey",
                        uppercase: true,
                        children: t("date_event")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (FormInfo_module_default())["info-text"],
                        color: "dark",
                        appearance: "bold",
                        children: date
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Forms/FormInfo/index.js


// EXTERNAL MODULE: ./src/components/Forms/FormRegistration/FormRegistration.module.scss
var FormRegistration_module = __webpack_require__(90588);
var FormRegistration_module_default = /*#__PURE__*/__webpack_require__.n(FormRegistration_module);
;// CONCATENATED MODULE: ./src/components/Forms/FormRegistration/FormRegistration.jsx









var FormRegistration = function(param) {
    var info = param.info;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useContext)(FormContent), data = ref.data, type = ref.type, title = ref.title, buttonText = ref.buttonText, fields = ref.fields, canBeSubmitted = ref.canBeSubmitted, metaData = ref.metaData, pending = ref.pending, onHandle = ref.onHandle, onSubmit = ref.onSubmit;
    (0,react.useEffect)(function() {
        if (canBeSubmitted) {
            onSubmit({
                type: type,
                data: data,
                metaData: metaData
            });
            dataLayerEvent("registration", {
                email: data === null || data === void 0 ? void 0 : data.email,
                phone: data === null || data === void 0 ? void 0 : data.phone
            });
        }
    }, [
        canBeSubmitted,
        data,
        metaData,
        onSubmit,
        type
    ]);
    var handleSubmit = function(e) {
        e.preventDefault();
        onHandle();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FormRegistration_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                        className: (FormRegistration_module_default()).title,
                        children: t(title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FormRegistration_module_default()).registration,
                        children: [
                            info,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                onSubmit: handleSubmit,
                                className: (FormRegistration_module_default()).form,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (FormRegistration_module_default())["input-group"],
                                    children: [
                                        fields.map(function(input) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* InputType */.n$, (0,_object_spread/* default */.Z)({}, input), input.id);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Action */.aU, {
                                            className: (FormRegistration_module_default()).submit,
                                            disabled: pending,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                    color: "brand",
                                                    appearance: "bold",
                                                    children: t(buttonText)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (FormRegistration_module_default()).arrow,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                        className: (FormRegistration_module_default()).icon,
                                                        name: "arrow_right"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSubmitStatus, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Forms/FormRegistration/index.js


// EXTERNAL MODULE: ./src/components/Forms/FormSubscription/FormSubscription.module.scss
var FormSubscription_module = __webpack_require__(59327);
var FormSubscription_module_default = /*#__PURE__*/__webpack_require__.n(FormSubscription_module);
;// CONCATENATED MODULE: ./src/components/Forms/FormSubscription/FormSubscription.jsx










var FormSubscription = function(param) {
    var className = param.className;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useContext)(FormContent), data = ref.data, type = ref.type, title = ref.title, fields = ref.fields, canBeSubmitted = ref.canBeSubmitted, pending = ref.pending, onHandle = ref.onHandle, onSubmit = ref.onSubmit;
    (0,react.useEffect)(function() {
        if (canBeSubmitted) {
            onSubmit({
                type: type,
                data: data
            });
            dataLayerEvent("subscription");
        }
    }, [
        canBeSubmitted,
        data,
        onSubmit,
        type
    ]);
    var handleSubmit = function(e) {
        e.preventDefault();
        onHandle();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((FormSubscription_module_default()).wrapper, (FormSubscription_module_default())[className]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FormSubscription_module_default()).blocks,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            className: classnames_default()((FormSubscription_module_default()).title, className),
                            children: t(title)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (FormSubscription_module_default()).subscribe,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                onSubmit: handleSubmit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (FormSubscription_module_default()).form,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (FormSubscription_module_default())["input-group"],
                                            children: fields.map(function(input) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* InputType */.n$, (0,_object_spread/* default */.Z)({}, input), input.id);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
                                            disabled: pending,
                                            className: (FormSubscription_module_default()).circles,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (FormSubscription_module_default()).arrow,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                    className: (FormSubscription_module_default()).icon,
                                                    name: "arrow_right"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSubmitStatus, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Forms/FormSubscription/index.js


;// CONCATENATED MODULE: ./src/components/Forms/FormType.jsx





var TYPE_CARD_MAPPING = {
    application: FormApplication,
    subscription: FormSubscription,
    registration: FormRegistration
};
var FormType = function(param) {
    var item = param.item, metaData = param.metaData, info = param.info, className = param.className, onReset = param.onReset;
    var Form = TYPE_CARD_MAPPING[item === null || item === void 0 ? void 0 : item.title];
    if (Form) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormProvider, {
            formData: item.formData,
            type: item.id,
            metaData: metaData,
            onResetCallback: onReset,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
                className: className,
                info: info
            })
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./src/components/Forms/index.js









/***/ }),

/***/ 3319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ LanguageSelector; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/LanguageSelector/InlineLanguages/InlineLanguages.module.scss
var InlineLanguages_module = __webpack_require__(99245);
var InlineLanguages_module_default = /*#__PURE__*/__webpack_require__.n(InlineLanguages_module);
;// CONCATENATED MODULE: ./src/components/LanguageSelector/InlineLanguages/InlineLanguages.jsx






var InlineLanguages = function(param) {
    var currentHref = param.currentHref, locale = param.locale, locales = param.locales;
    var t = (0,translations/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (InlineLanguages_module_default()).list,
        children: locales.map(function(localeKey) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: classnames_default()((InlineLanguages_module_default()).item, (0,_define_property/* default */.Z)({}, (InlineLanguages_module_default()).active, localeKey === locale)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: currentHref,
                    locale: localeKey,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: t("locale.".concat(localeKey))
                    })
                })
            }, localeKey);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/LanguageSelector/InlineLanguages/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
// EXTERNAL MODULE: ./src/components/LanguageSelector/InteractiveLanguages/InteractiveLanguages.module.scss
var InteractiveLanguages_module = __webpack_require__(92546);
var InteractiveLanguages_module_default = /*#__PURE__*/__webpack_require__.n(InteractiveLanguages_module);
;// CONCATENATED MODULE: ./src/components/LanguageSelector/InteractiveLanguages/InteractiveLanguages.jsx












var InteractiveLanguages = function(param) {
    var currentHref = param.currentHref, locale = param.locale, locales = param.locales;
    var ref = (0,react.useState)(false), opened = ref[0], setOpened = ref[1];
    var ref1 = (0,ViewMode/* useViewMode */.mJ)(), isMobile = ref1.isMobile, isDesktop = ref1.isDesktop;
    var t = (0,translations/* useTranslation */.$)().t;
    var closeList = (0,react.useCallback)(function() {
        return setOpened(false);
    }, []);
    var openList = (0,react.useCallback)(function() {
        return setOpened(true);
    }, []);
    var toggleList = (0,react.useCallback)(function() {
        return setOpened(function(current) {
            return !current;
        });
    }, []);
    var events = (0,_object_spread/* default */.Z)({}, isMobile && {
        onClick: toggleList
    }, isDesktop && {
        onMouseOver: openList,
        onMouseLeave: closeList
    });
    /**
   * close list if click outside the language selector element was happened
   */ var ref2 = (0,hooks/* useOutsideClick */.O3)(closeList);
    /**
   * close list if scroll was started
   */ (0,hooks/* useWindowScrollListener */.nf)(closeList, opened);
    var availableLocales = locales.filter(function(localeKey) {
        return localeKey !== locale;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (InteractiveLanguages_module_default()).wrapper
    }, events), {
        ref: ref2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: classnames_default()((InteractiveLanguages_module_default()).item, (0,_define_property/* default */.Z)({}, (InteractiveLanguages_module_default()).opened, opened)),
                children: [
                    t("locale.".concat(locale)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        className: (InteractiveLanguages_module_default()).icon,
                        name: "dropdown",
                        theme: opened ? "accent" : "default"
                    })
                ]
            }),
            opened && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (InteractiveLanguages_module_default()).list,
                children: availableLocales.map(function(localeKey) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (InteractiveLanguages_module_default()).item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: currentHref,
                            locale: localeKey,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: t("locale.".concat(localeKey))
                            })
                        })
                    }, localeKey);
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/LanguageSelector/InteractiveLanguages/index.js


// EXTERNAL MODULE: ./src/components/LanguageSelector/LanguageSelector.module.scss
var LanguageSelector_module = __webpack_require__(66081);
var LanguageSelector_module_default = /*#__PURE__*/__webpack_require__.n(LanguageSelector_module);
;// CONCATENATED MODULE: ./src/components/LanguageSelector/LanguageSelector.jsx






var LanguageSelector = function(param) {
    var _inline = param.inline, inline = _inline === void 0 ? false : _inline, _appearance = param.appearance, appearance = _appearance === void 0 ? "dark" : _appearance;
    var ref = (0,router.useRouter)(), pathname = ref.pathname, locale = ref.locale, locales = ref.locales, slug = ref.query.slug;
    var currentHref = slug ? {
        pathname: pathname,
        query: {
            slug: slug
        }
    } : pathname;
    var props = {
        locales: locales,
        locale: locale,
        currentHref: currentHref
    };
    var LanguagesVariation = inline ? InlineLanguages : InteractiveLanguages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LanguageSelector_module_default())[appearance],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagesVariation, (0,_object_spread/* default */.Z)({}, props))
    });
};

;// CONCATENATED MODULE: ./src/components/LanguageSelector/index.js



/***/ }),

/***/ 62569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Footer/index.js + 9 modules
var Footer = __webpack_require__(51712);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/components/CallButton/index.js + 1 modules
var CallButton = __webpack_require__(55005);
// EXTERNAL MODULE: ./src/components/LanguageSelector/index.js + 5 modules
var LanguageSelector = __webpack_require__(3319);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/shared/contexts/Menus/index.js + 4 modules
var Menus = __webpack_require__(37013);
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.module.scss
var Navigation_module = __webpack_require__(80040);
var Navigation_module_default = /*#__PURE__*/__webpack_require__.n(Navigation_module);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/components/Navigation/CoursesExtraLink/CoursesExtraLink.module.scss
var CoursesExtraLink_module = __webpack_require__(47417);
var CoursesExtraLink_module_default = /*#__PURE__*/__webpack_require__.n(CoursesExtraLink_module);
;// CONCATENATED MODULE: ./src/components/Navigation/CoursesExtraLink/CoursesExtraLink.jsx



var CoursesExtraLink = function(param) {
    var title = param.title, description = param.description, to = param.to;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
        link: to,
        className: (CoursesExtraLink_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CoursesExtraLink_module_default()).link,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (CoursesExtraLink_module_default()).text,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            color: "dark",
                            appearance: "bold",
                            className: (CoursesExtraLink_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            className: (CoursesExtraLink_module_default())["caption-general"],
                            color: "dark",
                            appearance: "smaller",
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CoursesExtraLink_module_default()).button,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        name: "arrow_right",
                        className: (CoursesExtraLink_module_default()).icon
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Navigation/CoursesExtraLink/index.js


// EXTERNAL MODULE: ./src/components/Navigation/HighlightedCourse/HighlightedCourse.module.scss
var HighlightedCourse_module = __webpack_require__(97361);
var HighlightedCourse_module_default = /*#__PURE__*/__webpack_require__.n(HighlightedCourse_module);
;// CONCATENATED MODULE: ./src/components/Navigation/HighlightedCourse/HighlightedCourse.jsx



var HighlightedCourse = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* PageLink */.H_, {
        link: data.url,
        target: data === null || data === void 0 ? void 0 : data.target,
        className: (HighlightedCourse_module_default()).link,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading4 */.k8, {
                color: "dark",
                appearance: "bold",
                uppercase: true,
                className: (HighlightedCourse_module_default()).title,
                children: data.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HighlightedCourse_module_default()).button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                    name: "arrow_right",
                    className: (HighlightedCourse_module_default()).icon
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Navigation/HighlightedCourse/index.js


// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Navigation/CoursesMenu/CoursesMenu.module.scss
var CoursesMenu_module = __webpack_require__(63309);
var CoursesMenu_module_default = /*#__PURE__*/__webpack_require__.n(CoursesMenu_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/components/Navigation/CoursesMenu/CoursesMenu.utils.js


var groupItems = function(items) {
    var itemsCopy = (0,_to_consumable_array/* default */.Z)(items);
    var highlightedIndex = itemsCopy.findIndex(function(item) {
        return Boolean(item.highlight);
    });
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((ref = itemsCopy.splice(highlightedIndex, 1)) !== null && ref !== void 0 ? ref : [], 1), highlighted = ref1[0];
    var uniqueLabels = (0,_to_consumable_array/* default */.Z)(new Set(itemsCopy.map(function(param) {
        var courseLabel = param.courseLabel;
        return courseLabel;
    }).filter(Boolean)));
    var groups = uniqueLabels.reduce(function(acc, label) {
        acc.push({
            label: label,
            items: itemsCopy.filter(function(param) {
                var courseLabel = param.courseLabel;
                return courseLabel === label;
            })
        });
        return acc;
    }, []);
    return {
        groups: groups,
        highlighted: highlighted
    };
};

;// CONCATENATED MODULE: ./src/components/Navigation/CoursesMenu/CoursesMenu.jsx








var CoursesMenu = function(param) {
    var items = param.items, caption = param.caption;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useMemo)(function() {
        return groupItems(items);
    }, [
        items
    ]), highlighted = ref.highlighted, groups = ref.groups;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CoursesMenu_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CoursesMenu_module_default()).groups,
                children: groups.map(function(param) {
                    var label = param.label, items = param.items;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CoursesMenu_module_default()).group,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CoursesMenu_module_default()).paper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading4 */.k8, {
                                    className: (CoursesMenu_module_default()).title,
                                    children: label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CoursesMenu_module_default()).items,
                                    children: items.map(function(param) {
                                        var title = param.title, url = param.url, target = param.target, caption = param.caption;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (CoursesMenu_module_default()).item,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                                                    link: url,
                                                    target: target,
                                                    className: (CoursesMenu_module_default()).link,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                        color: "dark",
                                                        appearance: "bold",
                                                        className: (CoursesMenu_module_default()).subtitle,
                                                        children: title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                    className: (CoursesMenu_module_default()).caption,
                                                    color: "dark",
                                                    appearance: "smaller",
                                                    children: caption
                                                })
                                            ]
                                        }, title);
                                    })
                                })
                            ]
                        })
                    }, label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CoursesMenu_module_default()).buttons,
                children: [
                    highlighted && /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedCourse, {
                        data: highlighted
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CoursesMenu_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursesExtraLink, {
                        to: "/programs/comparison",
                        title: t("comparison_title"),
                        description: t("comparison_caption")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CoursesMenu_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursesExtraLink, {
                        to: "/programs",
                        title: t("all_programs_title"),
                        description: caption || t("all_programs_caption")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Navigation/CoursesMenu/index.js


// EXTERNAL MODULE: ./src/components/Navigation/DropdownLinks/DropdownLinks.module.scss
var DropdownLinks_module = __webpack_require__(90794);
var DropdownLinks_module_default = /*#__PURE__*/__webpack_require__.n(DropdownLinks_module);
;// CONCATENATED MODULE: ./src/components/Navigation/DropdownLinks/DropdownLinks.jsx



var DropdownLinks = function(param) {
    var items = param.items;
    return items === null || items === void 0 ? void 0 : items.map(function(param) {
        var title = param.title, url = param.url, target = param.target;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (DropdownLinks_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                link: url,
                target: target,
                className: (DropdownLinks_module_default()).link,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                    color: "dark",
                    appearance: "bold",
                    children: title
                })
            })
        }, title);
    });
};

;// CONCATENATED MODULE: ./src/components/Navigation/DropdownLinks/index.js


// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
// EXTERNAL MODULE: ./src/components/Navigation/NavigationItem/NavigationItem.module.scss
var NavigationItem_module = __webpack_require__(22563);
var NavigationItem_module_default = /*#__PURE__*/__webpack_require__.n(NavigationItem_module);
;// CONCATENATED MODULE: ./src/components/Navigation/NavigationItem/NavigationItem.jsx








var NavigationItem = function(param) {
    var template = param.template, title = param.title, url = param.url, target = param.target, items = param.items, caption = param.caption;
    var ref, ref1;
    var ref2 = (0,react.useRef)(null);
    var ref3 = (0,hooks/* useToggle */.OT)(), opened = ref3.opened, onOpen = ref3.onOpen, onClose = ref3.onClose;
    var ref4;
    var dynamicStyles = {
        left: template !== "courses" ? (ref4 = (ref1 = ref2 === null || ref2 === void 0 ? void 0 : (ref = ref2.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.left) !== null && ref4 !== void 0 ? ref4 : "auto" : 0
    };
    (0,react.useEffect)(function() {
        router_default().events.on("routeChangeComplete", onClose);
        return function() {
            router_default().events.off("routeChangeComplete", onClose);
        };
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (NavigationItem_module_default()).item,
            onMouseOver: onOpen,
            ref: ref2,
            onMouseLeave: onClose,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                    link: url,
                    target: target,
                    className: (NavigationItem_module_default()).link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (NavigationItem_module_default()).title,
                        color: "dark",
                        appearance: "smaller",
                        uppercase: true,
                        children: title
                    })
                }),
                opened && items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Portal */.h_, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NavigationItem_module_default()).overlay,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NavigationItem_module_default()).dropdown,
                            style: dynamicStyles,
                            onMouseOver: onOpen,
                            onMouseLeave: onClose,
                            children: template === "courses" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursesMenu, {
                                items: items,
                                caption: caption
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLinks, {
                                items: items
                            })
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Navigation/NavigationItem/index.js


// EXTERNAL MODULE: ./src/components/Navigation/CoursesMobileMenu/CoursesMobileMenu.module.scss
var CoursesMobileMenu_module = __webpack_require__(48624);
var CoursesMobileMenu_module_default = /*#__PURE__*/__webpack_require__.n(CoursesMobileMenu_module);
;// CONCATENATED MODULE: ./src/components/Navigation/CoursesMobileMenu/CoursesMobileMenu.jsx









var CoursesMobileMenu = function(param) {
    var items = param.items, caption = param.caption;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useState)(null), opened = ref[0], setOpened = ref[1];
    var groups = (0,react.useMemo)(function() {
        return groupItems(items);
    }, [
        items
    ]).groups;
    var onToggle = (0,react.useCallback)(function(label) {
        return function() {
            setOpened(function(current) {
                return current === label ? null : label;
            });
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CoursesMobileMenu_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CoursesMobileMenu_module_default()).groups,
                children: groups.map(function(param) {
                    var label = param.label, items = param.items;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((CoursesMobileMenu_module_default()).group, (0,_define_property/* default */.Z)({}, (CoursesMobileMenu_module_default()).disabled, opened && opened !== label)),
                        onClick: onToggle(label),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                className: classnames_default()((CoursesMobileMenu_module_default()).label, (0,_define_property/* default */.Z)({}, (CoursesMobileMenu_module_default()).opened, opened === label)),
                                color: "light",
                                appearance: "bold",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (CoursesMobileMenu_module_default()).toggle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CoursesMobileMenu_module_default()).items,
                                children: opened === label && items.map(function(param) {
                                    var title = param.title, url = param.url, target = param.target, caption = param.caption;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* PageLink */.H_, {
                                        link: url,
                                        target: target,
                                        className: (CoursesMobileMenu_module_default()).item,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                color: "light",
                                                appearance: "bold",
                                                className: (CoursesMobileMenu_module_default()).title,
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                className: (CoursesMobileMenu_module_default()).caption,
                                                color: "light",
                                                appearance: "smaller",
                                                children: caption
                                            })
                                        ]
                                    }, title);
                                })
                            })
                        ]
                    }, label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CoursesMobileMenu_module_default()).buttons,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursesExtraLink, {
                        to: "/programs/comparison",
                        title: t("comparison_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (CoursesMobileMenu_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursesExtraLink, {
                        to: "/programs",
                        title: t("all_programs_title")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Navigation/CoursesMobileMenu/index.js


// EXTERNAL MODULE: ./src/components/Navigation/NavigationMobileItem/NavigationMobileItem.module.scss
var NavigationMobileItem_module = __webpack_require__(51151);
var NavigationMobileItem_module_default = /*#__PURE__*/__webpack_require__.n(NavigationMobileItem_module);
;// CONCATENATED MODULE: ./src/components/Navigation/NavigationMobileItem/NavigationMobileItem.jsx






var NavigationMobileItem = function(param) {
    var template = param.template, title = param.title, url = param.url, target = param.target, items = param.items;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), active = ref[0], setActive = ref[1];
    var onToggle = (0,react.useCallback)(function() {
        setActive(function(current) {
            return !current;
        });
    }, []);
    (0,react.useLayoutEffect)(function() {
        document.body.classList.add("is-frozen");
        return function() {
            document.body.classList.remove("is-frozen");
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NavigationMobileItem_module_default()).item,
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (NavigationMobileItem_module_default()).title,
                        color: "light",
                        appearance: "bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                        className: (NavigationMobileItem_module_default()).arrow,
                        icon: "arrow_right"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                link: url,
                target: target,
                className: (NavigationMobileItem_module_default()).link,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                    className: (NavigationMobileItem_module_default()).title,
                    color: "light",
                    appearance: "bold",
                    children: title
                })
            }),
            active && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Portal */.h_, {
                className: (NavigationMobileItem_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (NavigationMobileItem_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (NavigationMobileItem_module_default())["button-back"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                    className: (NavigationMobileItem_module_default()).arrow,
                                    icon: "back",
                                    onClick: onToggle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                    className: (NavigationMobileItem_module_default()).back,
                                    appearance: "smaller",
                                    children: t("back")
                                })
                            ]
                        }),
                        template === "courses" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursesMobileMenu, {
                            items: items
                        }) : items.map(function(param) {
                            var title = param.title, url = param.url;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                                link: url,
                                className: (NavigationMobileItem_module_default())["item-link"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                    className: (NavigationMobileItem_module_default())["item-title"],
                                    color: "light",
                                    appearance: "bold",
                                    children: title
                                })
                            }, title);
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Navigation/NavigationMobileItem/index.js


;// CONCATENATED MODULE: ./src/components/Navigation/Navigation.jsx










var Navigation = function() {
    var headerData = (0,Menus/* useMenusState */.iR)().headerData;
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: classnames_default()((Navigation_module_default()).nav, (0,_define_property/* default */.Z)({}, (Navigation_module_default())["nav-mobile"], !isDesktop)),
        children: headerData.map(function(_param) {
            var id = _param.id, rest = (0,_object_without_properties/* default */.Z)(_param, [
                "id"
            ]);
            return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem, (0,_object_spread/* default */.Z)({}, rest), id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationMobileItem, (0,_object_spread/* default */.Z)({}, rest), id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Navigation/index.js


;// CONCATENATED MODULE: ./src/components/SignInButton/SignInButton.jsx




var SignInButton = function(param) {
    var noTitle = param.noTitle, _noIcon = param.noIcon, noIcon = _noIcon === void 0 ? false : _noIcon, className = param.className, _theme = param.theme, theme = _theme === void 0 ? "dark" : _theme;
    var t = (0,translations/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
        as: "a",
        htmlAttributes: {
            href: "https://study.mim.kyiv.ua/login/index.php",
            target: "_blank"
        },
        icon: !noIcon && "profile",
        className: className,
        theme: theme,
        children: !noTitle ? t("Log_into_the_cabinet") : null
    });
};

;// CONCATENATED MODULE: ./src/components/SignInButton/index.js


// EXTERNAL MODULE: ./src/components/SocialSharing/index.js + 5 modules
var SocialSharing = __webpack_require__(96352);
// EXTERNAL MODULE: ./src/components/Header/DesktopHeader/DesktopHeader.module.scss
var DesktopHeader_module = __webpack_require__(66299);
var DesktopHeader_module_default = /*#__PURE__*/__webpack_require__.n(DesktopHeader_module);
;// CONCATENATED MODULE: ./src/components/Header/DesktopHeader/DesktopHeader.jsx








var DesktopHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (DesktopHeader_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            className: (DesktopHeader_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SiteLogo */.SO, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (DesktopHeader_module_default()).actions,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CallButton/* CallButton */.H, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SignInButton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelector/* LanguageSelector */.$, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialSharing/* SocialSharing */.e, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Header/DesktopHeader/index.js


// EXTERNAL MODULE: ./src/components/BurgerMenu/BurgerMenu.module.scss
var BurgerMenu_module = __webpack_require__(29570);
var BurgerMenu_module_default = /*#__PURE__*/__webpack_require__.n(BurgerMenu_module);
;// CONCATENATED MODULE: ./src/components/BurgerMenu/BurgerMenu.jsx











var BurgerMenu = function() {
    var ref = (0,hooks/* useToggle */.OT)(), opened = ref.opened, onToggle = ref.onToggle, onClose = ref.onClose;
    (0,react.useEffect)(function() {
        router_default().events.on("routeChangeComplete", onClose);
        return function() {
            router_default().events.off("routeChangeComplete", onClose);
        };
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                onClick: onToggle,
                className: classnames_default()((0,_define_property/* default */.Z)({}, (BurgerMenu_module_default()).active, opened)),
                icon: opened ? "close" : "menu",
                appearance: "default"
            }),
            opened && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Portal */.h_, {
                className: (BurgerMenu_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (BurgerMenu_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SignInButton, {
                            noIcon: true,
                            className: (BurgerMenu_module_default()).signin,
                            theme: "light"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialSharing/* SocialSharing */.e, {
                            inline: true
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/BurgerMenu/index.js


// EXTERNAL MODULE: ./src/components/Header/MobileHeader/MobileHeader.module.scss
var MobileHeader_module = __webpack_require__(62184);
var MobileHeader_module_default = /*#__PURE__*/__webpack_require__.n(MobileHeader_module);
;// CONCATENATED MODULE: ./src/components/Header/MobileHeader/MobileHeader.jsx







var MobileHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (MobileHeader_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MobileHeader_module_default()).left,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CallButton/* CallButton */.H, {
                        noTitle: true,
                        theme: "dark-reverse",
                        hover: "none"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignInButton, {
                        noTitle: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SiteLogo */.SO, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MobileHeader_module_default()).right,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelector/* LanguageSelector */.$, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerMenu, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Header/MobileHeader/index.js


;// CONCATENATED MODULE: ./src/components/Header/Header.jsx




var Header = function() {
    var isMobile = (0,ViewMode/* useViewMode */.mJ)().isMobile;
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHeader, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopHeader, {});
};

;// CONCATENATED MODULE: ./src/components/Header/index.js


;// CONCATENATED MODULE: ./src/components/Layout/Layout.jsx



var Layout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Layout/index.js



/***/ }),

/***/ 14258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ RichTextWidget; }
});

// UNUSED EXPORTS: RichTextWidgetRenderer

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/RichTextWidget/RichTextContainer/RichTextContainer.module.scss
var RichTextContainer_module = __webpack_require__(32617);
var RichTextContainer_module_default = /*#__PURE__*/__webpack_require__.n(RichTextContainer_module);
;// CONCATENATED MODULE: ./src/components/RichTextWidget/RichTextContainer/RichTextContainer.jsx




var RichTextContainer = function(param) {
    var children = param.children, className = param.className, _color = param.color, color = _color === void 0 ? "dark" : _color;
    var ref = (0,react.useState)(false), domLoaded = ref[0], setDomLoaded = ref[1];
    (0,react.useEffect)(function() {
        setDomLoaded(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: domLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            className: classnames_default()((RichTextContainer_module_default()).wysiwyg, className, (RichTextContainer_module_default())["color-".concat(color)]),
            children: children
        })
    });
};

;// CONCATENATED MODULE: ./src/components/RichTextWidget/RichTextContainer/index.js


;// CONCATENATED MODULE: ./src/components/RichTextWidget/RichTextWidget.config.js
var teacherWidgetsRegex = /{{teacher:[a-zA-Z0-9,-]+}}/g;
var teacherLinkWidgetsRegex = /{{teacher_link:[a-zA-Z0-9,-]+}}/g;
var teacherTimingWidgetsRegex = /{{teacher_timing:[a-zA-Z0-9,-]+:\s*{[а-яА-Яa-zA-Z0-9,\s*]+}\s*}}/g;
var WIDGETS_REGEXES = [
    teacherWidgetsRegex,
    teacherLinkWidgetsRegex,
    teacherTimingWidgetsRegex, 
];

;// CONCATENATED MODULE: ./src/components/RichTextWidget/RichTextWidget.utils.js

var extractChildData = function(node) {
    var ref, ref1;
    if (node.type !== "tag" || !Array.isArray(node.children)) {
        return null;
    }
    var ref2;
    var data = (ref2 = node === null || node === void 0 ? void 0 : (ref = node.children) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.data) !== null && ref2 !== void 0 ? ref2 : "";
    return data.length > 0 && isValidWidgetString(data) ? data : null;
};
var extractElementData = function(node) {
    if (node.type !== "text") {
        return null;
    }
    var ref;
    var textData = (ref = node === null || node === void 0 ? void 0 : node.data) !== null && ref !== void 0 ? ref : "";
    return textData.length > 0 && isValidWidgetString(textData) ? textData : null;
};
var isValidWidgetString = function(string) {
    return WIDGETS_REGEXES.some(function(regex) {
        return regex.test(string);
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/cms/index.js + 3 modules
var cms = __webpack_require__(49204);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/RichTextWidget/variations/TeacherList.hook.js





var useCollectedTeachers = function(param) {
    var payload = param.payload;
    var locale = (0,router.useRouter)().locale;
    var ref;
    var teachersSlug = (0,react.useMemo)(function() {
        return (ref = payload === null || payload === void 0 ? void 0 : payload.split(",")) !== null && ref !== void 0 ? ref : [];
    }, [
        payload
    ]);
    var ref1 = (0,react.useState)(null), teachers = ref1[0], setTeachers = ref1[1];
    (0,react.useEffect)(function() {
        if (teachersSlug.length > 0) {
            var collectedDataRender = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var ref, teachersData;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                _ctx.next = 3;
                                return (0,cms/* fetchAPI */.I)("/teachers", {
                                    populate: {
                                        photo: "*"
                                    },
                                    fields: [
                                        "title",
                                        "slug",
                                        "description"
                                    ],
                                    filters: {
                                        slug: {
                                            $in: teachersSlug
                                        }
                                    }
                                }, locale);
                            case 3:
                                _ctx.t1 = ref = _ctx.sent;
                                _ctx.t0 = _ctx.t1 !== null;
                                if (!_ctx.t0) {
                                    _ctx.next = 7;
                                    break;
                                }
                                _ctx.t0 = ref !== void 0;
                            case 7:
                                if (!_ctx.t0) {
                                    _ctx.next = 11;
                                    break;
                                }
                                _ctx.t2 = ref;
                                _ctx.next = 12;
                                break;
                            case 11:
                                _ctx.t2 = {
                                    data: []
                                };
                            case 12:
                                teachersData = _ctx.t2;
                                setTeachers(teachersData === null || teachersData === void 0 ? void 0 : teachersData.data);
                            case 14:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function collectedDataRender() {
                    return _ref.apply(this, arguments);
                };
            }();
            collectedDataRender();
        }
    }, [
        locale,
        teachersSlug,
        teachersSlug.length
    ]);
    return {
        teachers: teachers
    };
};

// EXTERNAL MODULE: ./src/components/RichTextWidget/variations/TeacherLink/TeacherLink.module.scss
var TeacherLink_module = __webpack_require__(45930);
var TeacherLink_module_default = /*#__PURE__*/__webpack_require__.n(TeacherLink_module);
;// CONCATENATED MODULE: ./src/components/RichTextWidget/variations/TeacherLink/TeacherLink.jsx










var TeacherLink = function(param) {
    var payload = param.payload;
    var t = (0,translations/* useTranslation */.$)().t;
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var teachers = useCollectedTeachers({
        payload: payload
    }).teachers;
    var ref = (0,hooks/* useToggle */.OT)(), opened = ref.opened, onOpen = ref.onOpen, onClose = ref.onClose;
    var events = (0,_object_spread/* default */.Z)({}, isDesktop && {
        onMouseOver: onOpen,
        onMouseLeave: onClose
    });
    var ref1 = (0,hooks/* useOutsideClick */.O3)(onClose);
    if (teachers) {
        var _teachers = (0,_sliced_to_array/* default */.Z)(teachers, 1), teacher = _teachers[0];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: (TeacherLink_module_default()).teacher
        }, events), {
            ref: ref1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                    directory: "teachers",
                    slug: teacher.slug,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (TeacherLink_module_default()).name,
                        color: "grey",
                        children: teacher.title
                    })
                }),
                opened && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                    className: (TeacherLink_module_default()).link,
                    directory: "teachers",
                    slug: teacher.slug,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TeacherLink_module_default()).tooltip,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                                image: teacher.photo,
                                className: (TeacherLink_module_default()).image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                className: (TeacherLink_module_default()).title,
                                children: teacher.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                className: (TeacherLink_module_default()).description,
                                children: teacher.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (TeacherLink_module_default()).arrow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                        children: t("read_more")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: (TeacherLink_module_default()).icon,
                                        name: "arrow_right"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        }));
    }
};

;// CONCATENATED MODULE: ./src/components/RichTextWidget/variations/TeacherLink/index.js


// EXTERNAL MODULE: ./src/components/RichTextWidget/variations/TeacherList/TeacherList.module.scss
var TeacherList_module = __webpack_require__(82305);
var TeacherList_module_default = /*#__PURE__*/__webpack_require__.n(TeacherList_module);
;// CONCATENATED MODULE: ./src/components/RichTextWidget/variations/TeacherList/TeacherList.jsx








var TeacherList = function(param) {
    var payload = param.payload, _timing = param.timing, timing = _timing === void 0 ? null : _timing;
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var ref = useCollectedTeachers({
        payload: payload
    }), rawTeachers = ref.teachers;
    var timingChunks = timing === null || timing === void 0 ? void 0 : timing.replace(/[{}]/g, "").split(",");
    var teachers = (0,react.useMemo)(function() {
        if (timing) {
            var _i;
            return rawTeachers === null || rawTeachers === void 0 ? void 0 : rawTeachers.map(function(item, i) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                    timing: (_i = timingChunks[i]) !== null && _i !== void 0 ? _i : ""
                });
            });
        }
        return rawTeachers;
    }, [
        rawTeachers,
        timing,
        timingChunks
    ]);
    if (!rawTeachers) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TeacherList_module_default()).teachers,
        children: teachers === null || teachers === void 0 ? void 0 : teachers.map(function(teacher) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* PageLink */.H_, {
                className: (TeacherList_module_default()).teacher,
                directory: "teachers",
                slug: teacher.slug,
                children: [
                    isDesktop && teacher.timing && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (TeacherList_module_default()).timing,
                        children: teacher.timing
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                        image: teacher.photo,
                        className: (TeacherList_module_default()).image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TeacherList_module_default()).text,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading7 */.Pb, {
                                className: (TeacherList_module_default()).title,
                                color: "light",
                                children: teacher.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                className: (TeacherList_module_default()).description,
                                color: "grey",
                                children: teacher.description
                            })
                        ]
                    })
                ]
            }, teacher.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/RichTextWidget/variations/TeacherList/index.js


;// CONCATENATED MODULE: ./src/components/RichTextWidget/RichTextWidgetRenderer.jsx




var EmptyWidget = function() {
    return null;
};
var RICH_WIDGET_TYPE = {
    teacher: TeacherList,
    teacher_link: TeacherLink,
    teacher_timing: TeacherList,
    _default: EmptyWidget
};
var RichTextWidgetRenderer = function(param) {
    var rawData = param.rawData;
    var chunks = rawData.replace(/[{}]/g, "").split(":");
    var _chunks = (0,_sliced_to_array/* default */.Z)(chunks, 3), type = _chunks[0], payload = _chunks[1], timing = _chunks[2];
    var _type;
    var MiniWidget = (_type = RICH_WIDGET_TYPE[type]) !== null && _type !== void 0 ? _type : RICH_WIDGET_TYPE._default;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniWidget, {
        payload: payload,
        timing: timing
    });
    return null;
};

;// CONCATENATED MODULE: ./src/components/RichTextWidget/RichTextWidget.jsx






var RichTextWidget = function(param) {
    var value = param.value, className = param.className, color = param.color;
    if (typeof value !== "string") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextContainer, {
        className: className,
        color: color,
        children: (0,html_react_parser/* default */.ZP)(value, {
            replace: function(domNode) {
                var widgetData = extractChildData(domNode) || extractElementData(domNode);
                if (widgetData !== null) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ErrorBoundary */.SV, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidgetRenderer, {
                            rawData: widgetData
                        })
                    });
                }
                return domNode;
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/RichTextWidget/index.js




/***/ }),

/***/ 21721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ List; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/contexts/Global/index.js + 5 modules
var Global = __webpack_require__(25330);
;// CONCATENATED MODULE: ./src/components/SocialSharing/List/List.jsx



var List = function(param) {
    var className = param.className, buttonClassName = param.buttonClassName, _appearance = param.appearance, appearance = _appearance === void 0 ? "dark" : _appearance;
    var socialNetworks = (0,Global/* useGlobalState */.j1)().socialNetworks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: className,
        children: socialNetworks.map(function(param) {
            var title = param.title, href = param.href, icon = param.icon;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                as: "a",
                htmlAttributes: {
                    href: href,
                    title: title,
                    target: "_blank"
                },
                icon: icon,
                className: buttonClassName,
                appearance: "outlined",
                theme: appearance,
                hover: appearance === "dark" ? "fill" : "reverse"
            }, "".concat(title, "_").concat(href, "_").concat(icon));
        })
    });
};

;// CONCATENATED MODULE: ./src/components/SocialSharing/List/index.js



/***/ }),

/***/ 96352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ SocialSharing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/SocialSharing/List/index.js + 1 modules
var List = __webpack_require__(21721);
// EXTERNAL MODULE: ./src/components/SocialSharing/InlineItems/InlineItems.module.scss
var InlineItems_module = __webpack_require__(40215);
var InlineItems_module_default = /*#__PURE__*/__webpack_require__.n(InlineItems_module);
;// CONCATENATED MODULE: ./src/components/SocialSharing/InlineItems/InlineItems.jsx



var InlineItems = function(param) {
    var _buttonClassName = param.buttonClassName, buttonClassName = _buttonClassName === void 0 ? (InlineItems_module_default()).button : _buttonClassName, _className = param.className, className = _className === void 0 ? (InlineItems_module_default()).list : _className, _appearance = param.appearance, appearance = _appearance === void 0 ? "light" : _appearance, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (InlineItems_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                className: className,
                buttonClassName: buttonClassName,
                appearance: appearance
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SocialSharing/InlineItems/index.js


// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
// EXTERNAL MODULE: ./src/components/SocialSharing/InteractiveItems/InteractiveItems.module.scss
var InteractiveItems_module = __webpack_require__(44198);
var InteractiveItems_module_default = /*#__PURE__*/__webpack_require__.n(InteractiveItems_module);
;// CONCATENATED MODULE: ./src/components/SocialSharing/InteractiveItems/InteractiveItems.jsx






var InteractiveItems = function() {
    var ref = (0,react.useState)(false), active = ref[0], setActive = ref[1];
    var clickHandler = (0,react.useCallback)(function() {
        return setActive(true);
    }, []);
    var outsideClickHandler = (0,react.useCallback)(function() {
        return setActive(false);
    }, []);
    var ref1 = (0,hooks/* useOutsideClick */.O3)(outsideClickHandler);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InteractiveItems_module_default()).wrapper,
        ref: ref1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                onClick: clickHandler,
                icon: "share",
                className: (InteractiveItems_module_default()).button,
                appearance: "outlined"
            }),
            active && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                className: (InteractiveItems_module_default()).list,
                buttonClassName: (InteractiveItems_module_default()).icon
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SocialSharing/InteractiveItems/index.js


;// CONCATENATED MODULE: ./src/components/SocialSharing/SocialSharing.jsx





var SocialSharing = function(_param) {
    var inline = _param.inline, props = (0,_object_without_properties/* default */.Z)(_param, [
        "inline"
    ]);
    return inline ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineItems, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InteractiveItems, (0,_object_spread/* default */.Z)({}, props));
};

;// CONCATENATED MODULE: ./src/components/SocialSharing/index.js



/***/ }),

/***/ 28986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ WidgetsRenderer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content002/index.js

var DynamicContent002 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4568).then(__webpack_require__.bind(__webpack_require__, 84568));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84568)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content003/index.js

var DynamicContent003 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4194).then(__webpack_require__.bind(__webpack_require__, 84194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84194)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content005/index.js

var DynamicContent005 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5649).then(__webpack_require__.bind(__webpack_require__, 95649));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95649)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/index.js

var DynamicContent006 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3850).then(__webpack_require__.bind(__webpack_require__, 3850));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3850)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content007/index.js

var DynamicContent007 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3583).then(__webpack_require__.bind(__webpack_require__, 23583));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23583)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content008/index.js

var DynamicContent008 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6437).then(__webpack_require__.bind(__webpack_require__, 6437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6437)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content009/index.js

var DynamicContent009 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9065).then(__webpack_require__.bind(__webpack_require__, 19065));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19065)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content010/index.js

var DynamicContent010 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 774).then(__webpack_require__.bind(__webpack_require__, 10774));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10774)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content012/index.js

var DynamicContent012 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3105).then(__webpack_require__.bind(__webpack_require__, 43105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43105)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content013/index.js

var DynamicContent013 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9450).then(__webpack_require__.bind(__webpack_require__, 9450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9450)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content015/index.js

var DynamicContent015 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 297).then(__webpack_require__.bind(__webpack_require__, 20297));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20297)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content017/index.js

var DynamicContent017 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8366).then(__webpack_require__.bind(__webpack_require__, 58366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58366)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content018/index.js

var DynamicContent018 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 304).then(__webpack_require__.bind(__webpack_require__, 40304));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40304)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content019/index.js

var DynamicContent019 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6545).then(__webpack_require__.bind(__webpack_require__, 6545));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6545)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content020/index.js

var DynamicContent020 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1640).then(__webpack_require__.bind(__webpack_require__, 91640));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91640)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content021/index.js

var DynamicContent021 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6564).then(__webpack_require__.bind(__webpack_require__, 96734));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96734)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content022/index.js

var DynamicContent022 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 384).then(__webpack_require__.bind(__webpack_require__, 10384));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10384)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content023/index.js

var DynamicContent023 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5631).then(__webpack_require__.bind(__webpack_require__, 95631));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95631)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content024/index.js

var DynamicContent024 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7394).then(__webpack_require__.bind(__webpack_require__, 77394));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77394)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content025/index.js

var DynamicContent025 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1045).then(__webpack_require__.bind(__webpack_require__, 91045));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91045)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content027/index.js

var DynamicContent027 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 484).then(__webpack_require__.bind(__webpack_require__, 20484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20484)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content035/index.js

var DynamicContent035 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9360).then(__webpack_require__.bind(__webpack_require__, 49360));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49360)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content038/index.js

var DynamicContent038 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3817).then(__webpack_require__.bind(__webpack_require__, 73817));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73817)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content040/index.js

var DynamicContent040 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1774).then(__webpack_require__.bind(__webpack_require__, 51774));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51774)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content041/index.js

var DynamicContent041 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4492).then(__webpack_require__.bind(__webpack_require__, 84492));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84492)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content042/index.js

var DynamicContent042 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2782).then(__webpack_require__.bind(__webpack_require__, 52782));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52782)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content043/index.js

var DynamicContent043 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5379).then(__webpack_require__.bind(__webpack_require__, 5379));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5379)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content044/index.js

var DynamicContent044 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 296).then(__webpack_require__.bind(__webpack_require__, 80296));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80296)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content045/index.js

var DynamicContent045 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5204).then(__webpack_require__.bind(__webpack_require__, 55204));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55204)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content046/index.js

var DynamicContent046 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4093).then(__webpack_require__.bind(__webpack_require__, 64093));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64093)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content049/index.js

var DynamicContent049 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3123).then(__webpack_require__.bind(__webpack_require__, 53123));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53123)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content050/index.js

var DynamicContent050 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7806).then(__webpack_require__.bind(__webpack_require__, 57806));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57806)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content051/index.js

var DynamicContent051 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1858).then(__webpack_require__.bind(__webpack_require__, 31858));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31858)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content052/index.js

var DynamicContent052 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9896).then(__webpack_require__.bind(__webpack_require__, 79896));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79896)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content053/index.js

var DynamicContent053 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5622).then(__webpack_require__.bind(__webpack_require__, 25622));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25622)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content054/index.js

var DynamicContent054 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5383).then(__webpack_require__.bind(__webpack_require__, 95383));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95383)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content055/index.js

var DynamicContent055 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2737).then(__webpack_require__.bind(__webpack_require__, 2737));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2737)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content056/index.js

var DynamicContent056 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8002).then(__webpack_require__.bind(__webpack_require__, 28002));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28002)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content057/index.js

var DynamicContent057 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4232).then(__webpack_require__.bind(__webpack_require__, 64232));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64232)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content058/index.js

var DynamicContent058 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8227).then(__webpack_require__.bind(__webpack_require__, 78227));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78227)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content059/index.js

var DynamicContent059 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1673).then(__webpack_require__.bind(__webpack_require__, 1673));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1673)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content060/index.js

var DynamicContent060 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5189).then(__webpack_require__.bind(__webpack_require__, 95189));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95189)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content061/index.js

var DynamicContent061 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5577).then(__webpack_require__.bind(__webpack_require__, 65577));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65577)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content062/index.js

var DynamicContent062 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5301).then(__webpack_require__.bind(__webpack_require__, 65301));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65301)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/index.js

var DynamicContent064 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6426).then(__webpack_require__.bind(__webpack_require__, 16426));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16426)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content066/index.js

var DynamicContent066 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 823).then(__webpack_require__.bind(__webpack_require__, 80823));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80823)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content067/index.js

var DynamicContent067 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2060).then(__webpack_require__.bind(__webpack_require__, 42060));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42060)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content068/index.js

var DynamicContent068 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6384).then(__webpack_require__.bind(__webpack_require__, 56384));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56384)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content069/index.js

var DynamicContent069 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7410).then(__webpack_require__.bind(__webpack_require__, 57410));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57410)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content071/index.js

var DynamicContent071 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2797).then(__webpack_require__.bind(__webpack_require__, 62797));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62797)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content072/index.js

var DynamicContent072 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7922).then(__webpack_require__.bind(__webpack_require__, 87922));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87922)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content074/index.js

var DynamicContent074 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6734).then(__webpack_require__.bind(__webpack_require__, 86734));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86734)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content075/index.js

var DynamicContent075 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4573).then(__webpack_require__.bind(__webpack_require__, 34573));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34573)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content076/index.js

var DynamicContent076 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2568).then(__webpack_require__.bind(__webpack_require__, 72568));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72568)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content079/index.js

var DynamicContent079 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3549).then(__webpack_require__.bind(__webpack_require__, 3549));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3549)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content080/index.js

var DynamicContent080 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7938).then(__webpack_require__.bind(__webpack_require__, 27938));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27938)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content083/index.js

var DynamicContent083 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1595).then(__webpack_require__.bind(__webpack_require__, 61595));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61595)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content084/index.js

var DynamicContent084 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4789).then(__webpack_require__.bind(__webpack_require__, 34789));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34789)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content085/index.js

var DynamicContent085 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6287).then(__webpack_require__.bind(__webpack_require__, 76287));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76287)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/Content0802/index.js

var DynamicContent0802 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8426).then(__webpack_require__.bind(__webpack_require__, 8426));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8426)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/content/index.js






























































var registerContentWidget = (0,widgets/* registerWidget */.jC)(widgets/* WIDGETS_REGISTRY.CONTENT */.Rg.CONTENT);
var contentWidgetsRegistry = (0,_object_spread/* default */.Z)({}, registerContentWidget("002", DynamicContent002), registerContentWidget("003", DynamicContent003), registerContentWidget("005", DynamicContent005), registerContentWidget("006", DynamicContent006), registerContentWidget("007", DynamicContent007), registerContentWidget("008", DynamicContent008), registerContentWidget("009", DynamicContent009), registerContentWidget("010", DynamicContent010), registerContentWidget("012", DynamicContent012), registerContentWidget("013", DynamicContent013), registerContentWidget("015", DynamicContent015), registerContentWidget("017", DynamicContent017), registerContentWidget("018", DynamicContent018), registerContentWidget("019", DynamicContent019), registerContentWidget("020", DynamicContent020), registerContentWidget("021", DynamicContent021), registerContentWidget("022", DynamicContent022), registerContentWidget("023", DynamicContent023), registerContentWidget("024", DynamicContent024), registerContentWidget("025", DynamicContent025), registerContentWidget("027", DynamicContent027), registerContentWidget("035", DynamicContent035), registerContentWidget("038", DynamicContent038), registerContentWidget("040", DynamicContent040), registerContentWidget("041", DynamicContent041), registerContentWidget("042", DynamicContent042), registerContentWidget("043", DynamicContent043), registerContentWidget("044", DynamicContent044), registerContentWidget("045", DynamicContent045), registerContentWidget("046", DynamicContent046), registerContentWidget("049", DynamicContent049), registerContentWidget("050", DynamicContent050), registerContentWidget("051", DynamicContent051), registerContentWidget("052", DynamicContent052), registerContentWidget("053", DynamicContent053), registerContentWidget("054", DynamicContent054), registerContentWidget("055", DynamicContent055), registerContentWidget("056", DynamicContent056), registerContentWidget("057", DynamicContent057), registerContentWidget("058", DynamicContent058), registerContentWidget("059", DynamicContent059), registerContentWidget("060", DynamicContent060), registerContentWidget("061", DynamicContent061), registerContentWidget("062", DynamicContent062), registerContentWidget("064", DynamicContent064), registerContentWidget("066", DynamicContent066), registerContentWidget("067", DynamicContent067), registerContentWidget("068", DynamicContent068), registerContentWidget("069", DynamicContent069), registerContentWidget("071", DynamicContent071), registerContentWidget("072", DynamicContent072), registerContentWidget("074", DynamicContent074), registerContentWidget("075", DynamicContent075), registerContentWidget("076", DynamicContent076), registerContentWidget("079", DynamicContent079), registerContentWidget("080", DynamicContent080), registerContentWidget("083", DynamicContent083), registerContentWidget("084", DynamicContent084), registerContentWidget("085", DynamicContent085), registerContentWidget("080-2", DynamicContent0802));

;// CONCATENATED MODULE: ./src/components/widgets/footer/Footer001/index.js

var DynamicFooter001 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1387).then(__webpack_require__.bind(__webpack_require__, 11387));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11387)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/footer/Footer002/index.js

var DynamicFooter002 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9323).then(__webpack_require__.bind(__webpack_require__, 59323));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59323)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/footer/Footer003/index.js

var DynamicFooter003 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4957).then(__webpack_require__.bind(__webpack_require__, 4957));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4957)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/footer/Footer005/index.js

var DynamicFooter005 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4680).then(__webpack_require__.bind(__webpack_require__, 64680));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64680)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/footer/index.js






var footer_registerContentWidget = (0,widgets/* registerWidget */.jC)(widgets/* WIDGETS_REGISTRY.FOOTER */.Rg.FOOTER);
var footerWidgetsRegistry = (0,_object_spread/* default */.Z)({}, footer_registerContentWidget("f001", DynamicFooter001), footer_registerContentWidget("f002", DynamicFooter002), footer_registerContentWidget("f003", DynamicFooter003), footer_registerContentWidget("f005", DynamicFooter005));

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero001/index.js

var DynamicHero001 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3708).then(__webpack_require__.bind(__webpack_require__, 73708));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73708)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero004/index.js

var DynamicHero004 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3382).then(__webpack_require__.bind(__webpack_require__, 23382));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23382)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero014/index.js

var DynamicHero014 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5477).then(__webpack_require__.bind(__webpack_require__, 85477));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85477)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero016/index.js

var DynamicHero016 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7725).then(__webpack_require__.bind(__webpack_require__, 57725));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57725)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero028/index.js

var DynamicHero028 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5017).then(__webpack_require__.bind(__webpack_require__, 55017));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55017)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero029/index.js

var DynamicHero029 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 239).then(__webpack_require__.bind(__webpack_require__, 80239));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80239)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero030/index.js

var DynamicHero030 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8582).then(__webpack_require__.bind(__webpack_require__, 58582));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58582)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero031/index.js

var DynamicHero031 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 494).then(__webpack_require__.bind(__webpack_require__, 60494));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60494)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero032/index.js

var DynamicHero032 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4553).then(__webpack_require__.bind(__webpack_require__, 84553));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84553)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero033/index.js

var DynamicHero033 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1898).then(__webpack_require__.bind(__webpack_require__, 31898));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31898)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero036/index.js

var DynamicHero036 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4536).then(__webpack_require__.bind(__webpack_require__, 64536));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64536)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero037/index.js

var DynamicHero037 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3703).then(__webpack_require__.bind(__webpack_require__, 93703));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93703)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero048/index.js

var DynamicHero048 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5533).then(__webpack_require__.bind(__webpack_require__, 65533));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65533)
            ];
        }
    },
    suspenses: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero063/index.js

var DynamicHero063 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4132).then(__webpack_require__.bind(__webpack_require__, 44132));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44132)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/Hero073/index.js

var DynamicHero073 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2758).then(__webpack_require__.bind(__webpack_require__, 42758));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42758)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/hero/index.js

















var hero_registerContentWidget = (0,widgets/* registerWidget */.jC)(widgets/* WIDGETS_REGISTRY.HERO */.Rg.HERO);
var heroWidgetsRegistry = (0,_object_spread/* default */.Z)({}, hero_registerContentWidget("001", DynamicHero001), hero_registerContentWidget("004", DynamicHero004), hero_registerContentWidget("014", DynamicHero014), hero_registerContentWidget("016", DynamicHero016), hero_registerContentWidget("028", DynamicHero028), hero_registerContentWidget("029", DynamicHero029), hero_registerContentWidget("030", DynamicHero030), hero_registerContentWidget("031", DynamicHero031), hero_registerContentWidget("032", DynamicHero032), hero_registerContentWidget("033", DynamicHero033), hero_registerContentWidget("036", DynamicHero036), hero_registerContentWidget("037", DynamicHero037), hero_registerContentWidget("048", DynamicHero048), hero_registerContentWidget("063", DynamicHero063), hero_registerContentWidget("073", DynamicHero073));

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/index.js

var DynamicLayoutWidget012 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7263).then(__webpack_require__.bind(__webpack_require__, 37263));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37263)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget013/index.js

var DynamicLayoutWidget013 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4452).then(__webpack_require__.bind(__webpack_require__, 4452));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4452)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget015/index.js

var DynamicLayoutWidget015 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2455).then(__webpack_require__.bind(__webpack_require__, 72455));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72455)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget031/index.js

var DynamicLayoutWidget031 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7561).then(__webpack_require__.bind(__webpack_require__, 47561));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47561)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget035/index.js

var DynamicLayoutWidget035 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7658).then(__webpack_require__.bind(__webpack_require__, 17658));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17658)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget066/index.js

var DynamicLayoutWidget066 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9688).then(__webpack_require__.bind(__webpack_require__, 39688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39688)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget079/index.js

var DynamicLayoutWidget079 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6177).then(__webpack_require__.bind(__webpack_require__, 6177));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6177)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget081/index.js

var DynamicLayoutWidget081 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9223).then(__webpack_require__.bind(__webpack_require__, 19223));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19223)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget082/index.js

var DynamicLayoutWidget082 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 999).then(__webpack_require__.bind(__webpack_require__, 80999));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80999)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget086/index.js

var DynamicLayoutWidget086 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1937).then(__webpack_require__.bind(__webpack_require__, 11937));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11937)
            ];
        }
    },
    suspense: true
});

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/index.js












var layout_widget_registerContentWidget = (0,widgets/* registerWidget */.jC)(widgets/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.Rg["LAYOUT-WIDGET"]);
var layoutWidgetsRegistry = (0,_object_spread/* default */.Z)({}, layout_widget_registerContentWidget("l012", DynamicLayoutWidget012), layout_widget_registerContentWidget("l013", DynamicLayoutWidget013), layout_widget_registerContentWidget("l015", DynamicLayoutWidget015), layout_widget_registerContentWidget("l031", DynamicLayoutWidget031), layout_widget_registerContentWidget("l035", DynamicLayoutWidget035), layout_widget_registerContentWidget("l066", DynamicLayoutWidget066), layout_widget_registerContentWidget("l079", DynamicLayoutWidget079), layout_widget_registerContentWidget("l081", DynamicLayoutWidget081), layout_widget_registerContentWidget("l082", DynamicLayoutWidget082), layout_widget_registerContentWidget("l086", DynamicLayoutWidget086));

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/WidgetsRenderer/WidgetsRenderer.jsx








var WidgetFallback = function(param) {
    var payload = param.payload;
    if (false) {}
    return null;
};
var nameToRegistryMapping = {
    footer: footerWidgetsRegistry,
    content: (0,_object_spread/* default */.Z)({}, contentWidgetsRegistry, heroWidgetsRegistry),
    "layout-widget": (0,_object_spread/* default */.Z)({}, layoutWidgetsRegistry)
};
function Widget(param) {
    var data = param.data, registryName = param.registryName, position = param.position;
    var ref, ref1;
    var widgetId = data.__component, payload = (0,_object_without_properties/* default */.Z)(data, [
        "__component"
    ]);
    var ref2;
    var resolvedRegistry = (ref2 = nameToRegistryMapping === null || nameToRegistryMapping === void 0 ? void 0 : nameToRegistryMapping[registryName]) !== null && ref2 !== void 0 ? ref2 : {};
    var ref3;
    var ResolvedWidget = (ref3 = resolvedRegistry === null || resolvedRegistry === void 0 ? void 0 : (ref = resolvedRegistry[widgetId]) === null || ref === void 0 ? void 0 : ref.component) !== null && ref3 !== void 0 ? ref3 : WidgetFallback;
    var ref4;
    var ResolvedSkeleton = (ref4 = resolvedRegistry === null || resolvedRegistry === void 0 ? void 0 : (ref1 = resolvedRegistry[widgetId]) === null || ref1 === void 0 ? void 0 : ref1.loader) !== null && ref4 !== void 0 ? ref4 : WidgetFallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResolvedSkeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResolvedWidget, {
            payload: payload,
            position: position
        })
    });
}
function WidgetsRenderer(param) {
    var items = param.items, registry = param.registry, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-widget-root": registry,
        className: className,
        children: items === null || items === void 0 ? void 0 : items.map(function(data, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-widget-position": index + 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget, {
                    data: data,
                    registryName: registry,
                    position: index + 1
                })
            }, "".concat(data.__component, "_").concat(data.id));
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetsRenderer/index.js



/***/ }),

/***/ 68642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Rg": function() { return /* reexport */ widgets_config/* WIDGETS_REGISTRY */.R; },
  "pz": function() { return /* reexport */ buildWidgetId; },
  "G1": function() { return /* reexport */ buildWidgetInstanceId; },
  "jC": function() { return /* reexport */ registerWidget; }
});

// EXTERNAL MODULE: ./src/features/widgets/widgets.config.js
var widgets_config = __webpack_require__(52853);
;// CONCATENATED MODULE: ./src/features/widgets/widgets.utils/buildWidgetId.js

var buildWidgetId = function(variation) {
    var widgetType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : widgets_config/* WIDGETS_REGISTRY.CONTENT */.R.CONTENT;
    return "".concat(widgetType, ".").concat(variation);
};
var buildWidgetInstanceId = function(variation, instanceId) {
    var widgetType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : widgets_config/* WIDGETS_REGISTRY.CONTENT */.R.CONTENT;
    return "".concat(widgetType, ".").concat(variation, ".").concat(instanceId);
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./src/features/widgets/widgets.utils/registerWidget.js



var registerWidget = function(registryPrefix) {
    return function(variation, dynamicComponent) {
        var skeleton = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        return (0,_define_property/* default */.Z)({}, buildWidgetId(variation, registryPrefix), (0,_object_spread/* default */.Z)({
            component: dynamicComponent
        }, skeleton && {
            skeleton: skeleton
        }));
    };
};

;// CONCATENATED MODULE: ./src/features/widgets/widgets.utils/index.js



;// CONCATENATED MODULE: ./src/features/widgets/index.js




/***/ }),

/***/ 52853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ WIDGETS_REGISTRY; }
/* harmony export */ });
var WIDGETS_REGISTRY = {
    CONTENT: "content-widgets",
    FOOTER: "footer-widgets",
    HERO: "hero-widgets",
    "LAYOUT-WIDGET": "layout-widgets"
};


/***/ }),

/***/ 41141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WJ": function() { return /* reexport */ LazyRenderingButton; },
  "Bv": function() { return /* reexport */ LazyRenderingProvider; },
  "vO": function() { return /* reexport */ useLazyRenderingState; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/shared/components/LazyRenderingButton/LazyRendering.Provider.jsx


var LazyRenderingContext = /*#__PURE__*/ (0,react.createContext)({});
var LazyRenderingProvider = function(param) {
    var children = param.children, size = param.size, initialLimit = param.initialLimit, incrementBy = param.incrementBy;
    var ref = (0,react.useState)(initialLimit), limit = ref[0], setLimit = ref[1];
    var isCompleted = (0,react.useMemo)(function() {
        return size < limit;
    }, [
        size,
        limit
    ]);
    var renderNext = (0,react.useCallback)(function() {
        if (!isCompleted) {
            setLimit(function(limit) {
                return limit + incrementBy;
            });
        }
    }, [
        isCompleted,
        incrementBy
    ]);
    var resetState = (0,react.useCallback)(function() {
        setLimit(initialLimit);
    }, [
        initialLimit
    ]);
    var value = {
        limit: limit,
        renderNext: renderNext,
        isCompleted: isCompleted,
        resetState: resetState
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyRenderingContext.Provider, {
        value: value,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/LazyRenderingButton/LazyRendering.hooks.jsx


var useLazyRenderingState = function() {
    return (0,react.useContext)(LazyRenderingContext);
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/components/LazyRenderingButton/LazyRenderingButton.module.scss
var LazyRenderingButton_module = __webpack_require__(46507);
var LazyRenderingButton_module_default = /*#__PURE__*/__webpack_require__.n(LazyRenderingButton_module);
;// CONCATENATED MODULE: ./src/shared/components/LazyRenderingButton/LazyRenderingButton.jsx







var LazyRenderingButton = function(param) {
    var appearance = param.appearance, buttonText = param.buttonText;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = useLazyRenderingState(), isCompleted = ref.isCompleted, renderNext = ref.renderNext;
    if (isCompleted) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
        onClick: renderNext,
        className: (LazyRenderingButton_module_default()).more,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (LazyRenderingButton_module_default()).loader,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((LazyRenderingButton_module_default())["loader-wrapper"], (LazyRenderingButton_module_default())[appearance]),
                children: [
                    buttonText || t("lazyRendering"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        className: (LazyRenderingButton_module_default()).icon,
                        name: "loader"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/LazyRenderingButton/index.js





/***/ }),

/***/ 81072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Poster; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47696);
/* harmony import */ var _Poster_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81431);
/* harmony import */ var _Poster_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Poster_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var Poster = function(param) {
    var appearance = param.appearance, title = param.title, image = param.image;
    var TitleElement = appearance === "default" ? shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv : shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading6 */ .Cd;
    var titleProps = appearance === "default" ? {
        appearance: "bold"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Poster_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_Poster_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inner),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Poster_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content), (_Poster_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[appearance]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleElement, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        className: (_Poster_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                        color: "light"
                    }, titleProps), {
                        children: title
                    }))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .ImageLite */ .NH, {
                    image: image,
                    className: (_Poster_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image)
                })
            ]
        })
    });
};


/***/ }),

/***/ 21472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ SiteLogo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/shared/contexts/Global/index.js + 5 modules
var Global = __webpack_require__(25330);
// EXTERNAL MODULE: ./src/shared/components/SiteLogo/SiteLogo.module.scss
var SiteLogo_module = __webpack_require__(87737);
var SiteLogo_module_default = /*#__PURE__*/__webpack_require__.n(SiteLogo_module);
;// CONCATENATED MODULE: ./src/shared/components/SiteLogo/SiteLogo.jsx




var SiteLogo = function(param) {
    var _type = param.type, type = _type === void 0 ? "header" : _type;
    var ref = (0,Global/* useGlobalState */.j1)(), logoHeader = ref.logoHeader, logoFooter = ref.logoFooter;
    var ref1;
    var headerUrl = (ref1 = logoHeader === null || logoHeader === void 0 ? void 0 : logoHeader.url) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var footerUrl = (ref2 = logoFooter === null || logoFooter === void 0 ? void 0 : logoFooter.url) !== null && ref2 !== void 0 ? ref2 : "";
    var src = type === "header" ? headerUrl : footerUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (SiteLogo_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: src,
                className: (SiteLogo_module_default()).image,
                alt: " "
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/SiteLogo/index.js



/***/ }),

/***/ 11742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$E": function() { return /* binding */ DEFAULT_TAB_ID; },
/* harmony export */   "RL": function() { return /* binding */ TabsContext; },
/* harmony export */   "X": function() { return /* binding */ TabsProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var TabsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var DEFAULT_TAB_ID = "default_tab_all";
var TabsProvider = function(param) {
    var children = param.children, items = param.items, defaultTab = param.defaultTab, tabsEnabled = param.tabsEnabled;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(items), rawItems = ref[0], setRawItems = ref[1];
    var initialTab = defaultTab ? DEFAULT_TAB_ID : rawItems === null || rawItems === void 0 ? void 0 : rawItems[0];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialTab), activeTab = ref1[0], setActiveTab = ref1[1];
    var setActiveTabHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(nextTab) {
        return setActiveTab(nextTab);
    }, []);
    var resetActiveTab = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setActiveTab(initialTab);
    }, [
        initialTab
    ]);
    var setItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(nextItems) {
        return setRawItems(nextItems);
    }, []);
    var isDefaultTab = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return activeTab === DEFAULT_TAB_ID;
    }, [
        activeTab
    ]);
    var tabs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return defaultTab ? [
            DEFAULT_TAB_ID
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(rawItems)) : rawItems;
    }, [
        rawItems,
        defaultTab
    ]);
    var activeTabIndex = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return tabs.findIndex(function(tab) {
            return tab === activeTab;
        });
    }, [
        tabs,
        activeTab
    ]);
    var value = {
        tabs: tabs,
        activeTab: activeTab,
        activeTabIndex: activeTabIndex,
        setActiveTab: setActiveTabHandler,
        resetActiveTab: resetActiveTab,
        setItems: setItems,
        isDefaultTab: isDefaultTab,
        tabsEnabled: tabsEnabled
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabsContext.Provider, {
        value: value,
        children: children
    });
};


/***/ }),

/***/ 60419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useTabsState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Tabs_Provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11742);


var useTabsState = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_Tabs_Provider__WEBPACK_IMPORTED_MODULE_1__/* .TabsContext */ .RL);
};


/***/ }),

/***/ 6271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nL": function() { return /* reexport */ Heading1; },
  "XJ": function() { return /* reexport */ Heading2; },
  "aC": function() { return /* reexport */ Heading3; },
  "k8": function() { return /* reexport */ Heading4; },
  "by": function() { return /* reexport */ Heading5; },
  "Cd": function() { return /* reexport */ Heading6; },
  "Pb": function() { return /* reexport */ Heading7; },
  "sN": function() { return /* reexport */ MenuItem; },
  "nv": function() { return /* reexport */ Paragraph; },
  "ZT": function() { return /* reexport */ Typography; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/components/Typography/Typography.module.scss
var Typography_module = __webpack_require__(7873);
var Typography_module_default = /*#__PURE__*/__webpack_require__.n(Typography_module);
;// CONCATENATED MODULE: ./src/shared/components/Typography/Typography.jsx







// type color = 'dark'|'light'|'grey'|'brand'
// type as = 'p'|'span'|'h1'...'h8'
var Typography = function(param) {
    var Element = param.as, _attributes = param.attributes, attributes = _attributes === void 0 ? {} : _attributes, children = param.children, className = param.className, color = param.color, uppercase = param.uppercase, plain = param.plain;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()(className, (Typography_module_default()).element, (Typography_module_default())["color-".concat(color)], (0,_define_property/* default */.Z)({}, (Typography_module_default()).uppercase, uppercase))
    }, attributes), {
        children: plain ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RichString */.Zi, {
            value: children
        })
    }));
};
Typography.defaultProps = {
    as: "p",
    color: "dark"
};

// EXTERNAL MODULE: ./src/shared/components/Typography/Heading1/Heading1.module.scss
var Heading1_module = __webpack_require__(59237);
var Heading1_module_default = /*#__PURE__*/__webpack_require__.n(Heading1_module);
;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading1/Heading1.jsx




var Heading1 = function(param) {
    var _as = param.as, as = _as === void 0 ? "h1" : _as, className = param.className, color = param.color, children = param.children, _plain = param.plain, plain = _plain === void 0 ? false : _plain;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
        className: classnames_default()(className, (Heading1_module_default()).element),
        color: color,
        as: as,
        plain: plain,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading1/index.js


// EXTERNAL MODULE: ./src/shared/components/Typography/Heading2/Heading2.module.scss
var Heading2_module = __webpack_require__(22332);
var Heading2_module_default = /*#__PURE__*/__webpack_require__.n(Heading2_module);
;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading2/Heading2.jsx




var Heading2 = function(param) {
    var _as = param.as, as = _as === void 0 ? "h2" : _as, className = param.className, color = param.color, children = param.children, _plain = param.plain, plain = _plain === void 0 ? false : _plain;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
        className: classnames_default()(className, (Heading2_module_default()).element),
        color: color,
        as: as,
        plain: plain,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading2/index.js


// EXTERNAL MODULE: ./src/shared/components/Typography/Heading3/Heading3.module.scss
var Heading3_module = __webpack_require__(36529);
var Heading3_module_default = /*#__PURE__*/__webpack_require__.n(Heading3_module);
;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading3/Heading3.jsx




var Heading3 = function(param) {
    var _as = param.as, as = _as === void 0 ? "h3" : _as, className = param.className, color = param.color, children = param.children, _plain = param.plain, plain = _plain === void 0 ? false : _plain;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
        className: classnames_default()(className, (Heading3_module_default()).element),
        color: color,
        as: as,
        plain: plain,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading3/index.js


// EXTERNAL MODULE: ./src/shared/components/Typography/Heading4/Heading4.module.scss
var Heading4_module = __webpack_require__(84979);
var Heading4_module_default = /*#__PURE__*/__webpack_require__.n(Heading4_module);
;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading4/Heading4.jsx




var Heading4 = function(param) {
    var _as = param.as, as = _as === void 0 ? "h4" : _as, className = param.className, color = param.color, children = param.children, _plain = param.plain, plain = _plain === void 0 ? false : _plain;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
        className: classnames_default()(className, (Heading4_module_default()).element),
        color: color,
        as: as,
        plain: plain,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading4/index.js


// EXTERNAL MODULE: ./src/shared/components/Typography/Heading5/Heading5.module.scss
var Heading5_module = __webpack_require__(97275);
var Heading5_module_default = /*#__PURE__*/__webpack_require__.n(Heading5_module);
;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading5/Heading5.jsx




var Heading5 = function(param) {
    var _as = param.as, as = _as === void 0 ? "h5" : _as, className = param.className, color = param.color, children = param.children, _plain = param.plain, plain = _plain === void 0 ? false : _plain;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
        className: classnames_default()(className, (Heading5_module_default()).element),
        color: color,
        as: as,
        plain: plain,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading5/index.js


// EXTERNAL MODULE: ./src/shared/components/Typography/Heading6/Heading6.module.scss
var Heading6_module = __webpack_require__(29898);
var Heading6_module_default = /*#__PURE__*/__webpack_require__.n(Heading6_module);
;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading6/Heading6.jsx




var Heading6 = function(param) {
    var _as = param.as, as = _as === void 0 ? "h6" : _as, className = param.className, color = param.color, children = param.children, _plain = param.plain, plain = _plain === void 0 ? false : _plain;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
        className: classnames_default()(className, (Heading6_module_default()).element),
        color: color,
        as: as,
        plain: plain,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading6/index.js


// EXTERNAL MODULE: ./src/shared/components/Typography/Heading7/Heading7.module.scss
var Heading7_module = __webpack_require__(33668);
var Heading7_module_default = /*#__PURE__*/__webpack_require__.n(Heading7_module);
;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading7/Heading7.jsx




var Heading7 = function(param) {
    var _as = param.as, as = _as === void 0 ? "p" : _as, className = param.className, color = param.color, children = param.children, _plain = param.plain, plain = _plain === void 0 ? false : _plain;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
        className: classnames_default()(className, (Heading7_module_default()).element),
        color: color,
        as: as,
        plain: plain,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Typography/Heading7/index.js


// EXTERNAL MODULE: ./src/shared/components/Typography/MenuItem/MenuItem.module.scss
var MenuItem_module = __webpack_require__(85025);
var MenuItem_module_default = /*#__PURE__*/__webpack_require__.n(MenuItem_module);
;// CONCATENATED MODULE: ./src/shared/components/Typography/MenuItem/MenuItem.jsx




var MenuItem = function(param) {
    var className = param.className, color = param.color, children = param.children, href = param.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
        as: "a",
        uppercase: true,
        color: color,
        className: classnames_default()(className, (MenuItem_module_default()).element),
        attributes: {
            href: href
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Typography/MenuItem/index.js


// EXTERNAL MODULE: ./src/shared/components/Typography/Paragraph/Paragraph.module.scss
var Paragraph_module = __webpack_require__(1732);
var Paragraph_module_default = /*#__PURE__*/__webpack_require__.n(Paragraph_module);
;// CONCATENATED MODULE: ./src/shared/components/Typography/Paragraph/Paragraph.jsx




// type appearance = 'bold'|'bigger'|'smaller'
var Paragraph = function(param) {
    var _as = param.as, as = _as === void 0 ? "p" : _as, className = param.className, color = param.color, appearance = param.appearance, uppercase = param.uppercase, children = param.children, _plain = param.plain, plain = _plain === void 0 ? false : _plain;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
        className: classnames_default()(className, (Paragraph_module_default()).element, (Paragraph_module_default())["appearance-".concat(appearance)]),
        color: color,
        uppercase: uppercase,
        as: as,
        plain: plain,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Typography/Paragraph/index.js


;// CONCATENATED MODULE: ./src/shared/components/Typography/index.js












/***/ }),

/***/ 47696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ES": function() { return /* reexport */ AccordionList; },
  "aU": function() { return /* reexport */ Action; },
  "Fy": function() { return /* reexport */ AttachmentsList; },
  "V6": function() { return /* reexport */ Blockquote; },
  "zx": function() { return /* reexport */ Button; },
  "W2": function() { return /* reexport */ Container; },
  "IR": function() { return /* reexport */ DetailsBlock; },
  "xn": function() { return /* reexport */ DownloadFile; },
  "SV": function() { return /* reexport */ ErrorBoundary; },
  "nL": function() { return /* reexport */ Typography/* Heading1 */.nL; },
  "XJ": function() { return /* reexport */ Typography/* Heading2 */.XJ; },
  "aC": function() { return /* reexport */ Typography/* Heading3 */.aC; },
  "k8": function() { return /* reexport */ Typography/* Heading4 */.k8; },
  "by": function() { return /* reexport */ Typography/* Heading5 */.by; },
  "Cd": function() { return /* reexport */ Typography/* Heading6 */.Cd; },
  "Pb": function() { return /* reexport */ Typography/* Heading7 */.Pb; },
  "KW": function() { return /* reexport */ HighlightedArticle; },
  "JO": function() { return /* reexport */ Icon; },
  "NH": function() { return /* reexport */ ImageLite; },
  "n$": function() { return /* reexport */ InputType; },
  "WJ": function() { return /* reexport */ LazyRenderingButton/* LazyRenderingButton */.WJ; },
  "AB": function() { return /* reexport */ ModalWrapper; },
  "d2": function() { return /* reexport */ NewsItems; },
  "GS": function() { return /* reexport */ OrderedList; },
  "H_": function() { return /* reexport */ PageLink; },
  "nv": function() { return /* reexport */ Typography/* Paragraph */.nv; },
  "Dj": function() { return /* reexport */ PopularTags; },
  "h_": function() { return /* reexport */ Portal; },
  "$b": function() { return /* reexport */ RenderIf; },
  "Zi": function() { return /* reexport */ RichString; },
  "SO": function() { return /* reexport */ SiteLogo/* SiteLogo */.S; },
  "cV": function() { return /* reexport */ StickableContent; },
  "OJ": function() { return /* reexport */ SwiperLayout; },
  "mQ": function() { return /* reexport */ Tabs; },
  "tL": function() { return /* reexport */ YoutubeVideo; }
});

// UNUSED EXPORTS: AllTags, Poster, Redirect, Typography

// NAMESPACE OBJECT: ./src/shared/components/Icon/icons/index.js
var icons_namespaceObject = {};
__webpack_require__.r(icons_namespaceObject);
__webpack_require__.d(icons_namespaceObject, {
  "address": function() { return address; },
  "arrow_right": function() { return arrow_right; },
  "arrow_slider_next": function() { return arrow_slider_next; },
  "arrow_slider_prev": function() { return arrow_slider_prev; },
  "back": function() { return back; },
  "blockquote": function() { return blockquote; },
  "calendar": function() { return calendar; },
  "checkmark": function() { return checkmark; },
  "checkmark_thin": function() { return checkmark_thin; },
  "chevron_down": function() { return chevron_down; },
  "chevron_left": function() { return chevron_left; },
  "chevron_right": function() { return chevron_right; },
  "chevron_up": function() { return chevron_up; },
  "clock": function() { return clock; },
  "close": function() { return icons_close; },
  "close_white": function() { return close_white; },
  "comment": function() { return comment; },
  "done": function() { return done; },
  "download": function() { return download; },
  "dropdown": function() { return dropdown; },
  "dropdown_arrow": function() { return dropdown_arrow; },
  "email": function() { return email; },
  "facebook": function() { return facebook; },
  "file": function() { return file; },
  "instagram": function() { return instagram; },
  "large_arrow_down": function() { return large_arrow_down; },
  "large_arrow_right": function() { return large_arrow_right; },
  "linkedin": function() { return linkedin; },
  "loader": function() { return loader; },
  "long_arrow_left": function() { return long_arrow_left; },
  "menu": function() { return menu; },
  "message": function() { return message; },
  "more": function() { return more; },
  "pin": function() { return pin; },
  "play": function() { return play; },
  "plus": function() { return plus; },
  "profile": function() { return profile; },
  "rounded_chevron_down": function() { return rounded_chevron_down; },
  "share": function() { return share; },
  "tag": function() { return tag; },
  "tel": function() { return tel; },
  "telegram": function() { return telegram; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/AccordionList/AccordionList.module.scss
var AccordionList_module = __webpack_require__(64453);
var AccordionList_module_default = /*#__PURE__*/__webpack_require__.n(AccordionList_module);
;// CONCATENATED MODULE: ./src/shared/components/AccordionList/AccordionList.jsx







var AccordionList = function(param) {
    var items = param.items, appearance = param.appearance, _color = param.color, color = _color === void 0 ? "dark" : _color, className = param.className, togglePlus = param.togglePlus;
    var formatCounter = function(number) {
        return number > 9 ? number : "0".concat(number);
    };
    var ref = (0,react.useState)(null), selected = ref[0], setSelected = ref[1];
    var onOpen = function(id) {
        return function(e) {
            if (e.target) {
                setSelected(id === selected ? null : id);
            }
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((AccordionList_module_default()).wrapper, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            className: (AccordionList_module_default()).list,
            children: items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: classnames_default()((AccordionList_module_default())["list-item"], (0,_define_property/* default */.Z)({}, (AccordionList_module_default()).opened, selected === item.id)),
                    onClick: onOpen(item.id),
                    children: [
                        togglePlus ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AccordionList_module_default()).circle
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading6 */.Cd, {
                            color: "brand",
                            as: "span",
                            className: (AccordionList_module_default()).subtitle,
                            plain: true,
                            children: item.subtitle || formatCounter(index + 1)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                            as: "p",
                            className: classnames_default()((AccordionList_module_default()).title, (AccordionList_module_default())[appearance]),
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AccordionList_module_default()).description,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                color: color,
                                value: item.description
                            })
                        }),
                        !togglePlus && item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AccordionList_module_default()).dropdown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                name: "dropdown",
                                className: (AccordionList_module_default()).icon
                            })
                        })
                    ]
                }, item.id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/AccordionList/index.js


// EXTERNAL MODULE: ./src/shared/components/Action/Action.module.scss
var Action_module = __webpack_require__(47688);
var Action_module_default = /*#__PURE__*/__webpack_require__.n(Action_module);
;// CONCATENATED MODULE: ./src/shared/components/Action/Action.jsx



var Action = function(param) {
    var children = param.children, className = param.className, onClick = param.onClick, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        disabled: disabled,
        className: classnames_default()((Action_module_default()).wrapper, className),
        onClick: onClick,
        tabIndex: "-1",
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Action/index.js


// EXTERNAL MODULE: ./src/shared/components/AttachmentsList/AttachmentsList.module.scss
var AttachmentsList_module = __webpack_require__(89934);
var AttachmentsList_module_default = /*#__PURE__*/__webpack_require__.n(AttachmentsList_module);
;// CONCATENATED MODULE: ./src/shared/components/AttachmentsList/AttachmentsList.jsx




var AttachmentsList = function(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AttachmentsList_module_default()).wrapper,
        children: items.map(function(attachment) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (AttachmentsList_module_default()).file,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                        value: attachment.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadFile, {
                        file: attachment.media
                    })
                ]
            }, attachment.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/AttachmentsList/index.js


// EXTERNAL MODULE: ./src/shared/components/Blockquote/Blockquote.module.scss
var Blockquote_module = __webpack_require__(31667);
var Blockquote_module_default = /*#__PURE__*/__webpack_require__.n(Blockquote_module);
;// CONCATENATED MODULE: ./src/shared/components/Blockquote/Blockquote.jsx




var Blockquote = function(param) {
    var image = param.image, author = param.author, position = param.position, quote = param.quote, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Blockquote_module_default()).wrapper, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Blockquote_module_default()).quote,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        name: "blockquote",
                        className: (Blockquote_module_default()).icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading6 */.Cd, {
                        className: (Blockquote_module_default()).text,
                        color: "light",
                        children: quote
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Blockquote_module_default()).person,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLite, {
                        image: image,
                        className: (Blockquote_module_default()).image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Blockquote_module_default()).details,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                                className: (Blockquote_module_default()).author,
                                color: "light",
                                children: author
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                                className: (Blockquote_module_default()).position,
                                color: "grey",
                                children: position
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Blockquote/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/shared/components/Icon/Icon.module.scss
var Icon_module = __webpack_require__(25343);
var Icon_module_default = /*#__PURE__*/__webpack_require__.n(Icon_module);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/address.svg
var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#address_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m7.93 15.89.07.07.07-.07 4.243-4.243a6.1 6.1 0 1 0-8.626 0l.07-.071-.07.07 4.242 4.243ZM8 13.791l-3.23-3.23a4.566 4.566 0 1 1 6.46 0L8 13.793ZM6.986 8.347A1.433 1.433 0 1 0 9.014 6.32a1.433 1.433 0 0 0-2.028 2.027Z",
    fill: "var(--native-icon-fill)",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "address_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "var(--native-icon-secondary-fill)",
    d: "M0 0h16v16H0z"
  })))));
};

/* harmony default export */ var address = (SvgAddress);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/arrow-right.svg
var _path, _path2;

function arrow_right_extends() { arrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_right_extends.apply(this, arguments); }



var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_right_extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m12 2 10 10-10 10",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "var(--native-icon-fill)",
    d: "M1 11h21v2H1z"
  })));
};

/* harmony default export */ var arrow_right = (SvgArrowRight);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/arrow-slider-next.svg
var arrow_slider_next_path;

function arrow_slider_next_extends() { arrow_slider_next_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_slider_next_extends.apply(this, arguments); }



var SvgArrowSliderNext = function SvgArrowSliderNext(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_slider_next_extends({
    width: 124,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_slider_next_path || (arrow_slider_next_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 4.5 119.89 0l-.866.949L121.81 4H0v1h121.81l-2.786 3.051.866.949L124 4.5Z",
    fill: "#8B8B95"
  })));
};

/* harmony default export */ var arrow_slider_next = (SvgArrowSliderNext);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/arrow-slider-prev.svg
var arrow_slider_prev_path;

function arrow_slider_prev_extends() { arrow_slider_prev_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_slider_prev_extends.apply(this, arguments); }



var SvgArrowSliderPrev = function SvgArrowSliderPrev(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_slider_prev_extends({
    width: 124,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_slider_prev_path || (arrow_slider_prev_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.5 4.11 0l.866.949L2.19 4H124v1H2.19l2.786 3.051L4.11 9 0 4.5Z",
    fill: "#8B8B95"
  })));
};

/* harmony default export */ var arrow_slider_prev = (SvgArrowSliderPrev);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/back.svg
var back_path;

function back_extends() { back_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return back_extends.apply(this, arguments); }



var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/react.createElement("svg", back_extends({
    viewBox: "-2 -3 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), back_path || (back_path = /*#__PURE__*/react.createElement("path", {
    d: "M3.083 4.248 6.35.886 5.49 0 .75 4.875 5.49 9.75l.861-.886-3.268-3.362H10.5V4.248H3.083Z",
    fill: "#7A95CB",
    fillOpacity: 0.9
  })));
};

/* harmony default export */ var back = (SvgBack);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/blockquote.svg
var blockquote_path;

function blockquote_extends() { blockquote_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return blockquote_extends.apply(this, arguments); }



var SvgBlockquote = function SvgBlockquote(props) {
  return /*#__PURE__*/react.createElement("svg", blockquote_extends({
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), blockquote_path || (blockquote_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 38 7.714 0h13.5l-5.143 38H0Zm23.786 0L31.5 0H45l-5.143 38H23.786Z",
    fill: "#CE1050"
  })));
};

/* harmony default export */ var blockquote = (SvgBlockquote);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/calendar.svg
var calendar_path;

function calendar_extends() { calendar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calendar_extends.apply(this, arguments); }



var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react.createElement("svg", calendar_extends({
    width: 16,
    height: 16,
    fill: "var(--native-icon-fill)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), calendar_path || (calendar_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3 2.4a.7.7 0 0 1 .7.7v11.2a.7.7 0 0 1-.7.7H1.7a.7.7 0 0 1-.7-.7V3.1a.7.7 0 0 1 .7-.7h2.8V1h1.4v1.4h4.2V1h1.4v1.4h2.8ZM5.9 3.8v1.4H4.5V3.8H2.4v2.8h11.2V3.8h-2.1v1.4h-1.4V3.8H5.9ZM2.4 8v5.6h11.2V8H2.4Z"
  })));
};

/* harmony default export */ var calendar = (SvgCalendar);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/checkmark.svg
var checkmark_path;

function checkmark_extends() { checkmark_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return checkmark_extends.apply(this, arguments); }



var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/react.createElement("svg", checkmark_extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), checkmark_path || (checkmark_path = /*#__PURE__*/react.createElement("path", {
    d: "m3 6 2 2 4-4",
    stroke: "var(--native-icon-fill)"
  })));
};

/* harmony default export */ var checkmark = (SvgCheckmark);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/checkmark-thin.svg
var checkmark_thin_path;

function checkmark_thin_extends() { checkmark_thin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return checkmark_thin_extends.apply(this, arguments); }



var SvgCheckmarkThin = function SvgCheckmarkThin(props) {
  return /*#__PURE__*/react.createElement("svg", checkmark_thin_extends({
    width: 58,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), checkmark_thin_path || (checkmark_thin_path = /*#__PURE__*/react.createElement("path", {
    d: "m1 18 21 16.5L57 1",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

/* harmony default export */ var checkmark_thin = (SvgCheckmarkThin);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/chevron-down.svg
var chevron_down_path;

function chevron_down_extends() { chevron_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_down_extends.apply(this, arguments); }



var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_down_extends({
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--native-icon-fill)"
  }, props), chevron_down_path || (chevron_down_path = /*#__PURE__*/react.createElement("path", {
    d: "m16 8-1.455-1.455-5.506 5.506L8 12.9l-1.039-.848-5.506-5.507L0 8l8 8z"
  })));
};

/* harmony default export */ var chevron_down = (SvgChevronDown);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/chevron-left.svg
var chevron_left_path;

function chevron_left_extends() { chevron_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_left_extends.apply(this, arguments); }



var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_left_extends({
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--native-icon-fill)"
  }, props), chevron_left_path || (chevron_left_path = /*#__PURE__*/react.createElement("path", {
    d: "m8 16 1.455-1.455-5.506-5.506L3.1 8l.848-1.039 5.507-5.506L8 0 0 8z"
  })));
};

/* harmony default export */ var chevron_left = (SvgChevronLeft);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/chevron-right.svg
var chevron_right_path;

function chevron_right_extends() { chevron_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_right_extends.apply(this, arguments); }



var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_right_extends({
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--native-icon-fill)"
  }, props), chevron_right_path || (chevron_right_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 0 6.545 1.455l5.506 5.506L12.9 8l-.848 1.039-5.507 5.506L8 16l8-8z"
  })));
};

/* harmony default export */ var chevron_right = (SvgChevronRight);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/chevron-up.svg
var chevron_up_path;

function chevron_up_extends() { chevron_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_up_extends.apply(this, arguments); }



var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_up_extends({
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--native-icon-fill)"
  }, props), chevron_up_path || (chevron_up_path = /*#__PURE__*/react.createElement("path", {
    d: "m0 8 1.455 1.455 5.506-5.506L8 3.1l1.039.848 5.506 5.507L16 8 8 0z"
  })));
};

/* harmony default export */ var chevron_up = (SvgChevronUp);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/clock.svg
var clock_path, clock_path2;

function clock_extends() { clock_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clock_extends.apply(this, arguments); }



var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/react.createElement("svg", clock_extends({
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), clock_path || (clock_path = /*#__PURE__*/react.createElement("path", {
    d: "M7 0C3.14 0 0 3.14 0 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7Zm0 12.6A5.607 5.607 0 0 1 1.4 7c0-3.088 2.512-5.6 5.6-5.6 3.088 0 5.6 2.512 5.6 5.6 0 3.088-2.512 5.6-5.6 5.6Z",
    fill: "#8B8B95"
  })), clock_path2 || (clock_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M7.689 6.798a.697.697 0 0 0 .01-.11v-3.05a.7.7 0 0 0-1.399 0v3.05c0 .06-.007.738.213.935l2.165 1.94a.696.696 0 0 0 .988-.053.7.7 0 0 0-.054-.988L7.689 6.798Z",
    fill: "#8B8B95"
  })));
};

/* harmony default export */ var clock = (SvgClock);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/close.svg
var close_g, close_defs;

function close_extends() { close_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return close_extends.apply(this, arguments); }



var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/react.createElement("svg", close_extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), close_g || (close_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#close_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M6.586 8 2.343 3.757l1.414-1.414L8 6.586l4.243-4.243 1.414 1.414L9.414 8l4.243 4.243-1.414 1.414L8 9.414l-4.243 4.243-1.414-1.414L6.586 8Z",
    fill: "var(--native-icon-fill)"
  }))), close_defs || (close_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "close_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

/* harmony default export */ var icons_close = (SvgClose);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/close_white.svg
var close_white_g, close_white_defs;

function close_white_extends() { close_white_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return close_white_extends.apply(this, arguments); }



var SvgCloseWhite = function SvgCloseWhite(props) {
  return /*#__PURE__*/react.createElement("svg", close_white_extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), close_white_g || (close_white_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#close_white_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M6.586 8 2.343 3.757l1.414-1.414L8 6.586l4.243-4.243 1.414 1.414L9.414 8l4.243 4.243-1.414 1.414L8 9.414l-4.243 4.243-1.414-1.414L6.586 8Z",
    fill: "#fff"
  }))), close_white_defs || (close_white_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "close_white_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

/* harmony default export */ var close_white = (SvgCloseWhite);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/comment.svg
var comment_path;

function comment_extends() { comment_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return comment_extends.apply(this, arguments); }



var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/react.createElement("svg", comment_extends({
    width: 16,
    height: 16,
    fill: "var(--native-icon-fill)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), comment_path || (comment_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.319 4.465c.211-.485.52-.926.91-1.297.39-.371.854-.665 1.364-.866C4.103 2.102 4.649 2 5.2 2h5.6C13.12 2 15 3.797 15 5.996V14H5.2C2.88 14 1 12.203 1 10.004V5.996c0-.525.108-1.045.319-1.53ZM13.6 5.996a2.607 2.607 0 0 0-.822-1.882 2.875 2.875 0 0 0-1.978-.78H5.2c-.368-.002-.732.067-1.072.2-.34.134-.648.33-.908.577-.26.247-.467.541-.608.865a2.55 2.55 0 0 0-.212 1.02v4.008c.002.706.298 1.383.822 1.882.525.5 1.236.78 1.978.78h8.4v-6.67Zm-2.8 1.337v1.334H9.4V7.333h1.4Zm-4.2 0v1.334H5.2V7.333h1.4Z"
  })));
};

/* harmony default export */ var comment = (SvgComment);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/done.svg
var done_path;

function done_extends() { done_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return done_extends.apply(this, arguments); }



var SvgDone = function SvgDone(props) {
  return /*#__PURE__*/react.createElement("svg", done_extends({
    viewBox: "0 0 58 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), done_path || (done_path = /*#__PURE__*/react.createElement("path", {
    d: "m1 18 21 16.5L57 1",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

/* harmony default export */ var done = (SvgDone);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/download.svg
var download_path, _rect;

function download_extends() { download_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return download_extends.apply(this, arguments); }



var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/react.createElement("svg", download_extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), download_path || (download_path = /*#__PURE__*/react.createElement("path", {
    d: "M22.5 35.833h15V37.5h-15v-1.667Zm8.333-4.856 5.06-5.06 1.178 1.178L30 34.167l-7.07-7.071 1.178-1.18 5.059 5.059v-9.308h1.666v9.31Z",
    fill: "#CE1050"
  })), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#C8C7CF"
  })));
};

/* harmony default export */ var download = (SvgDownload);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/dropdown.svg
var dropdown_path;

function dropdown_extends() { dropdown_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dropdown_extends.apply(this, arguments); }



var SvgDropdown = function SvgDropdown(props) {
  return /*#__PURE__*/react.createElement("svg", dropdown_extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), dropdown_path || (dropdown_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.707 9.293a1 1 0 0 1-1.414 0L1.707 6.707C1.077 6.077 1.523 5 2.414 5h5.172c.89 0 1.337 1.077.707 1.707L5.707 9.293Z",
    fill: "var(--native-icon-fill)"
  })));
};

/* harmony default export */ var dropdown = (SvgDropdown);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/dropdown-arrow.svg
var dropdown_arrow_path;

function dropdown_arrow_extends() { dropdown_arrow_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dropdown_arrow_extends.apply(this, arguments); }



var SvgDropdownArrow = function SvgDropdownArrow(props) {
  return /*#__PURE__*/react.createElement("svg", dropdown_arrow_extends({
    width: 9,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), dropdown_arrow_path || (dropdown_arrow_path = /*#__PURE__*/react.createElement("path", {
    d: "m0 .943 4.278 4.471L8.556.943 7.654 0 4.278 3.528.902 0 0 .943Z",
    fill: "#18162C"
  })));
};

/* harmony default export */ var dropdown_arrow = (SvgDropdownArrow);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/email.svg
var email_path;

function email_extends() { email_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return email_extends.apply(this, arguments); }



var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/react.createElement("svg", email_extends({
    width: 16,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), email_path || (email_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.77 1H2.23C1.55 1 1 1.554 1 2.23v7.383c0 .68.555 1.23 1.23 1.23h11.54c.674 0 1.23-.547 1.23-1.23V2.23C15 1.555 14.452 1 13.77 1Zm-.173.82L8.87 6.523c-.232.232-.541.36-.87.36-.329 0-.638-.128-.87-.361L2.402 1.82h11.194ZM1.82 9.446V2.398l3.545 3.526L1.82 9.446Zm.583.577 3.544-3.52.603.6c.387.387.902.6 1.45.6.548 0 1.063-.213 1.45-.6l.603-.6 3.544 3.52H2.403Zm11.777-.577-3.545-3.522 3.545-3.526v7.048Z",
    fill: "var(--native-icon-fill)",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 0.5
  })));
};

/* harmony default export */ var email = (SvgEmail);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/facebook.svg
var facebook_path;

function facebook_extends() { facebook_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return facebook_extends.apply(this, arguments); }



var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/react.createElement("svg", facebook_extends({
    width: 16,
    height: 16,
    fill: "var(--native-icon-fill)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), facebook_path || (facebook_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.238 9.05 12 6.25H9.333v-1.4c0-.721 0-1.4 1.524-1.4H12V1.098A23.34 23.34 0 0 0 9.823 1C7.755 1 6.286 2.16 6.286 4.29v1.96H4v2.8h2.286V15h3.047V9.05h1.905Z"
  })));
};

/* harmony default export */ var facebook = (SvgFacebook);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/file.svg
var file_path;

function file_extends() { file_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return file_extends.apply(this, arguments); }



var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/react.createElement("svg", file_extends({
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), file_path || (file_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 0H0v38h32V8l-4.5-4-4-4ZM27 14H5v3h22v-3ZM5 20h22v3H5v-3Zm16 6H5v3h16v-3Z",
    fill: "#DFE0E7"
  })));
};

/* harmony default export */ var file = (SvgFile);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/instagram.svg
var instagram_path;

function instagram_extends() { instagram_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return instagram_extends.apply(this, arguments); }



var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/react.createElement("svg", instagram_extends({
    width: 16,
    height: 16,
    fill: "var(--native-icon-fill)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), instagram_path || (instagram_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 5.9a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2Zm0-1.4a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm4.55-.175a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0ZM8 2.4c-1.732 0-2.015.005-2.82.04-.55.026-.917.1-1.259.233a2.02 2.02 0 0 0-.756.492c-.219.212-.387.47-.493.756-.133.343-.206.71-.231 1.259C2.404 5.952 2.4 6.223 2.4 8c0 1.732.005 2.015.04 2.82.026.548.1.917.232 1.258.12.305.26.524.492.756.236.235.455.376.756.492.346.134.714.208 1.26.233.772.037 1.043.041 2.82.041 1.732 0 2.015-.005 2.82-.04.548-.027.917-.1 1.258-.232.303-.119.524-.26.756-.492.236-.236.377-.455.493-.756.133-.345.207-.714.232-1.26.037-.773.041-1.043.041-2.82 0-1.732-.005-2.015-.04-2.82-.027-.548-.1-.917-.233-1.259a2.037 2.037 0 0 0-.492-.756 2.019 2.019 0 0 0-.756-.493c-.343-.133-.711-.206-1.259-.231C10.047 2.404 9.777 2.4 8 2.4ZM8 1c1.902 0 2.14.007 2.885.042.746.035 1.253.152 1.7.325.462.178.851.42 1.24.808.356.35.632.773.808 1.24.172.446.29.954.325 1.7.033.746.042.983.042 2.885 0 1.902-.007 2.14-.042 2.885-.035.746-.153 1.253-.325 1.7-.176.467-.451.89-.808 1.24-.35.356-.773.632-1.24.808-.446.172-.954.29-1.7.325C10.14 14.991 9.902 15 8 15c-1.902 0-2.14-.007-2.885-.042-.746-.035-1.253-.153-1.7-.325a3.423 3.423 0 0 1-1.24-.808 3.433 3.433 0 0 1-.807-1.24c-.174-.446-.291-.954-.326-1.7C1.009 10.14 1 9.902 1 8c0-1.902.007-2.14.042-2.885.035-.747.152-1.253.325-1.7.176-.467.451-.89.808-1.24.35-.357.773-.632 1.24-.807.447-.174.953-.291 1.7-.326C5.86 1.009 6.098 1 8 1Z"
  })));
};

/* harmony default export */ var instagram = (SvgInstagram);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/large-arrow-down.svg
var _clipPath, large_arrow_down_g;

function large_arrow_down_extends() { large_arrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return large_arrow_down_extends.apply(this, arguments); }



var SvgLargeArrowDown = function SvgLargeArrowDown(props) {
  return /*#__PURE__*/react.createElement("svg", large_arrow_down_extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/react.createElement("clipPath", {
    id: "large-arrow-down_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 0h24v24H0z",
    transform: "rotate(90 12 12)"
  }))), large_arrow_down_g || (large_arrow_down_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#large-arrow-down_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M22 12 12 22 2 12",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 2
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13 1v21h-2V1z",
    fill: "var(--native-icon-fill)"
  }))));
};

/* harmony default export */ var large_arrow_down = (SvgLargeArrowDown);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/large-arrow-right.svg
var large_arrow_right_path, large_arrow_right_path2;

function large_arrow_right_extends() { large_arrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return large_arrow_right_extends.apply(this, arguments); }



var SvgLargeArrowRight = function SvgLargeArrowRight(props) {
  return /*#__PURE__*/react.createElement("svg", large_arrow_right_extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), large_arrow_right_path || (large_arrow_right_path = /*#__PURE__*/react.createElement("path", {
    d: "m12 2 10 10-10 10",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 2
  })), large_arrow_right_path2 || (large_arrow_right_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M1 11h21v2H1z",
    fill: "var(--native-icon-fill)"
  })));
};

/* harmony default export */ var large_arrow_right = (SvgLargeArrowRight);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/linkedin.svg
var linkedin_g, linkedin_defs;

function linkedin_extends() { linkedin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linkedin_extends.apply(this, arguments); }



var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/react.createElement("svg", linkedin_extends({
    width: 16,
    height: 16,
    fill: "var(--native-icon-fill)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), linkedin_g || (linkedin_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#linkedin_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M14.997 15H15V9.864c0-2.512-.54-4.447-3.477-4.447-1.412 0-2.359.775-2.746 1.51h-.04V5.652H5.951v9.346h2.9v-4.628c0-1.218.23-2.397 1.74-2.397 1.486 0 1.508 1.39 1.508 2.475V15h2.897ZM1.23 5.653h2.903V15H1.23V5.653ZM2.681 1C1.753 1 1 1.753 1 2.681s.753 1.697 1.681 1.697 1.681-.769 1.681-1.697S3.61 1 2.682 1Z"
  }))), linkedin_defs || (linkedin_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "linkedin_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    transform: "translate(1 1)",
    d: "M0 0h14v14H0z"
  })))));
};

/* harmony default export */ var linkedin = (SvgLinkedin);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/loader.svg
var loader_rect, loader_path, loader_g;

function loader_extends() { loader_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return loader_extends.apply(this, arguments); }



var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/react.createElement("svg", loader_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), loader_rect || (loader_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#18162C"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "loader_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, loader_path || (loader_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M6 6h12v12H6z"
  }))), loader_g || (loader_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#loader_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7a5 5 0 0 1 4.095 7.87L14.5 12H16a4 4 0 0 0-6.77-2.886l-.499-.897A4.98 4.98 0 0 1 12 7Zm0 10a5 5 0 0 1-4.095-7.87L9.5 12H8a4 4 0 0 0 6.77 2.886l.498.898A4.98 4.98 0 0 1 12 17Z",
    fill: "#fff"
  }))));
};

/* harmony default export */ var loader = (SvgLoader);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/long-arrow-left.svg
var long_arrow_left_path;

function long_arrow_left_extends() { long_arrow_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return long_arrow_left_extends.apply(this, arguments); }



var SvgLongArrowLeft = function SvgLongArrowLeft(props) {
  return /*#__PURE__*/react.createElement("svg", long_arrow_left_extends({
    width: 70,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), long_arrow_left_path || (long_arrow_left_path = /*#__PURE__*/react.createElement("path", {
    d: "m6.11 9.664 4.359-4.482L9.319 4 3 10.5 9.32 17l1.149-1.182-4.359-4.482H70V9.664H6.11Z",
    fill: "var(--native-icon-fill)"
  })));
};

/* harmony default export */ var long_arrow_left = (SvgLongArrowLeft);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/menu.svg
var menu_path;

function menu_extends() { menu_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }



var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/react.createElement("svg", menu_extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), menu_path || (menu_path = /*#__PURE__*/react.createElement("path", {
    d: "M1 12.964h16M6.714 7.25H17M1 1.535h16",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ var menu = (SvgMenu);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/message.svg
var message_path, message_g;

function message_extends() { message_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return message_extends.apply(this, arguments); }



var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/react.createElement("svg", message_extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("mask", {
    id: "message_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, message_path || (message_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  }))), message_g || (message_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#message_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.842 5.024A4.492 4.492 0 0 1 6 2.25h6c2.485 0 4.5 2.021 4.5 4.496v9.004H6a4.504 4.504 0 0 1-4.5-4.495v-4.51c0-.59.116-1.175.342-1.721ZM15 6.746a3.003 3.003 0 0 0-3-2.996H6a2.992 2.992 0 0 0-3 2.996v4.508a3.003 3.003 0 0 0 3 2.996h9V6.746ZM12 8.25v1.5h-1.5v-1.5H12Zm-4.5 0v1.5H6v-1.5h1.5Z",
    fill: "#fff"
  }))));
};

/* harmony default export */ var message = (SvgMessage);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/more.svg
var more_rect, _mask, more_g;

function more_extends() { more_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return more_extends.apply(this, arguments); }



var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/react.createElement("svg", more_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), more_rect || (more_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "var(--native-icon-fill)"
  })), _mask || (_mask = /*#__PURE__*/react.createElement("mask", {
    id: "more_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, /*#__PURE__*/react.createElement("path", {
    fill: "var(--native-icon-secondary-fill)",
    d: "M6 6h12v12H6z"
  }))), more_g || (more_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#more_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7a5 5 0 0 1 4.095 7.87L14.5 12H16a4 4 0 0 0-6.77-2.886l-.498-.897A4.98 4.98 0 0 1 12 7Zm0 10a5 5 0 0 1-4.095-7.87L9.5 12H8a4 4 0 0 0 6.77 2.886l.498.898A4.98 4.98 0 0 1 12 17Z",
    fill: "var(--native-icon-fill)"
  }))));
};

/* harmony default export */ var more = (SvgMore);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/pin.svg
var pin_path, pin_path2, _path3;

function pin_extends() { pin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pin_extends.apply(this, arguments); }



var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/react.createElement("svg", pin_extends({
    width: 38,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), pin_path || (pin_path = /*#__PURE__*/react.createElement("path", {
    d: "M38 19.309C38 29.972 22.912 46 19 46 15.088 46 0 29.973 0 19.309 0 8.645 8.507 0 19 0s19 8.645 19 19.309Z",
    fill: "var(--native-icon-fill)"
  })), pin_path2 || (pin_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M8.094 24.277H30.08c.61 0 1.094-.484 1.094-1.094v-9.72S30.943 13 30.08 13c-.863 0-1.094.463-1.094.463v8.626H9.209v-8.626S8.978 13 8.115 13C7.231 13 7 13.463 7 13.463v9.72c0 .61.484 1.094 1.094 1.094Z",
    fill: "var(--native-icon-secondary-fill)"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M19.099 20.195c.61 0 1.094-.483 1.094-1.094v-5.638S19.96 13 19.099 13c-.863 0-1.095.463-1.095.463V19.1c-.02.59.484 1.094 1.095 1.094ZM23.977 18.953s.232.21.61.21c.38 0 .61-.21.61-.21l2.736-2.945s.294-.316.294-.568v-2.104c-.252 0-.568.294-.568.294l-3.072 3.177-3.05-3.176s-.316-.295-.568-.295v2.125c0 .252.294.568.294.568l2.714 2.924ZM12.996 18.953s.252.21.61.21c.379 0 .61-.21.61-.21l2.735-2.945s.295-.316.295-.568v-2.104c-.253 0-.59.294-.59.294l-3.07 3.177-3.052-3.176s-.315-.295-.589-.295v2.125c0 .252.295.568.295.568l2.756 2.924Z",
    fill: "var(--native-icon-secondary-fill)"
  })));
};

/* harmony default export */ var pin = (SvgPin);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/play.svg
var play_path;

function play_extends() { play_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return play_extends.apply(this, arguments); }



var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/react.createElement("svg", play_extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), play_path || (play_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6 7.24a.921.921 0 0 1 0 1.52L4.53 15.82c-.638.449-1.53.006-1.53-.759V.939c0-.765.892-1.208 1.53-.76L14.6 7.24Z",
    fill: "var(--native-icon-fill)"
  })));
};

/* harmony default export */ var play = (SvgPlay);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/plus.svg
var plus_path;

function plus_extends() { plus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_extends.apply(this, arguments); }



var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/react.createElement("svg", plus_extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), plus_path || (plus_path = /*#__PURE__*/react.createElement("path", {
    d: "M7 7V1h2v6h6v2H9v6H7V9H1V7h6Z",
    fill: "var(--native-icon-fill)"
  })));
};

/* harmony default export */ var plus = (SvgPlus);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/profile.svg
var profile_path, _circle;

function profile_extends() { profile_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return profile_extends.apply(this, arguments); }



var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/react.createElement("svg", profile_extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), profile_path || (profile_path = /*#__PURE__*/react.createElement("path", {
    d: "M15 15v-1.667C15 11.493 13.433 10 11.5 10h-7C2.567 10 1 11.492 1 13.333V15",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 3,
    stroke: "var(--native-icon-fill)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ var profile = (SvgProfile);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/rounded-chevron-down.svg
var rounded_chevron_down_path;

function rounded_chevron_down_extends() { rounded_chevron_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rounded_chevron_down_extends.apply(this, arguments); }



var SvgRoundedChevronDown = function SvgRoundedChevronDown(props) {
  return /*#__PURE__*/react.createElement("svg", rounded_chevron_down_extends({
    fill: "none",
    height: 7,
    width: 11,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), rounded_chevron_down_path || (rounded_chevron_down_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 1 5.5 5 1 1",
    stroke: "var(--native-icon-fill)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
};

/* harmony default export */ var rounded_chevron_down = (SvgRoundedChevronDown);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/share.svg
var share_circle, _circle2, _circle3, share_path;

function share_extends() { share_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return share_extends.apply(this, arguments); }



var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/react.createElement("svg", share_extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), share_circle || (share_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 3,
    cy: 8,
    r: 2,
    stroke: "var(--native-icon-fill)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 2,
    stroke: "var(--native-icon-fill)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2,
    stroke: "var(--native-icon-fill)",
    strokeWidth: 2
  })), share_path || (share_path = /*#__PURE__*/react.createElement("path", {
    d: "m5 7 6-3.5M11 12.5l-6-3",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 2
  })));
};

/* harmony default export */ var share = (SvgShare);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/tag.svg
var tag_path, tag_circle, tag_path2;

function tag_extends() { tag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tag_extends.apply(this, arguments); }



var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/react.createElement("svg", tag_extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--native-icon-fill)"
  }, props), tag_path || (tag_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63 1.113a.662.662 0 0 1 .74 0L14 4.903v9.424c0 .178-.07.35-.195.476a.663.663 0 0 1-.472.197H2.667a.663.663 0 0 1-.472-.197.676.676 0 0 1-.195-.476V4.903l5.63-3.79Zm-4.297 12.54h9.334v-8.03L8 2.483l-4.667 3.14v8.03Z"
  })), tag_circle || (tag_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 1
  })), tag_path2 || (tag_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M6 9h4v1H6zM6 11h4v1H6z"
  })));
};

/* harmony default export */ var tag = (SvgTag);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/tel.svg
var tel_path;

function tel_extends() { tel_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tel_extends.apply(this, arguments); }



var SvgTel = function SvgTel(props) {
  return /*#__PURE__*/react.createElement("svg", tel_extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), tel_path || (tel_path = /*#__PURE__*/react.createElement("path", {
    clipRule: "evenodd",
    d: "M13 9.984v1.807a1.203 1.203 0 0 1-1.316 1.204 11.955 11.955 0 0 1-5.207-1.848 11.754 11.754 0 0 1-3.62-3.613 11.902 11.902 0 0 1-1.852-5.221A1.203 1.203 0 0 1 2.205 1h1.81a1.206 1.206 0 0 1 1.207 1.036 7.72 7.72 0 0 0 .423 1.692c.165.44.06.936-.272 1.27l-.766.765a9.644 9.644 0 0 0 3.62 3.613l.766-.765c.335-.33.832-.436 1.273-.27a7.76 7.76 0 0 0 1.696.42A1.205 1.205 0 0 1 13 9.985Z",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ var tel = (SvgTel);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/telegram.svg
var telegram_g, telegram_defs;

function telegram_extends() { telegram_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return telegram_extends.apply(this, arguments); }



var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/react.createElement("svg", telegram_extends({
    fill: "var(--native-icon-fill)",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), telegram_g || (telegram_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#telegram_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m6.493 9.856-.231 3.257c.331 0 .475-.142.647-.313l1.553-1.485 3.219 2.357c.59.33 1.006.156 1.165-.543l2.113-9.9c.188-.873-.315-1.215-.89-1L1.65 6.983c-.847.33-.834.802-.143 1.016l3.175.987 7.375-4.614c.347-.23.663-.103.403.127L6.493 9.856Z"
  }))), telegram_defs || (telegram_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "telegram_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    transform: "translate(1 1)",
    d: "M0 0h14v14H0z"
  })))));
};

/* harmony default export */ var telegram = (SvgTelegram);
;// CONCATENATED MODULE: ./src/shared/components/Icon/icons/index.js











































;// CONCATENATED MODULE: ./src/shared/components/Icon/NativeIcon.jsx



var NativeIcon = function(param) {
    var name = param.name;
    var ref;
    var ResolvedIcon = (ref = icons_namespaceObject === null || icons_namespaceObject === void 0 ? void 0 : icons_namespaceObject[name]) !== null && ref !== void 0 ? ref : react.Fragment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResolvedIcon, {});
};

;// CONCATENATED MODULE: ./src/shared/components/Icon/Icon.jsx




var Icon = function(param) {
    var className = param.className, name = param.name, _theme = param.theme, theme = _theme === void 0 ? "default" : _theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()((Icon_module_default()).image, (Icon_module_default())[theme], className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeIcon, {
            name: name
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Icon/index.js



// EXTERNAL MODULE: ./src/shared/components/Button/Button.module.scss
var Button_module = __webpack_require__(17756);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./src/shared/components/Button/Button.jsx







var Button = function(param) {
    var tmp = param.as, HtmlElement = tmp === void 0 ? "button" : tmp, _htmlAttributes = param.htmlAttributes, htmlAttributes = _htmlAttributes === void 0 ? {} : _htmlAttributes, _icon = param.icon, icon = _icon === void 0 ? "" : _icon, _children = param.children, children = _children === void 0 ? null : _children, _appearance = param.appearance, appearance = _appearance === void 0 ? "default" : _appearance, onClick = param.onClick, className = param.className, _theme = param.theme, theme = _theme === void 0 ? "dark" : _theme, _hover = param.hover, hover = _hover === void 0 ? "highlight" : _hover;
    var elementProps = (0,_object_spread/* default */.Z)({}, htmlAttributes, onClick && {
        onClick: onClick
    });
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HtmlElement, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, elementProps), {
        className: classnames_default()((Button_module_default()).button, (Button_module_default())[hover], (Button_module_default())[theme], (Button_module_default())[appearance], className, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Button_module_default())["no-icon"], !icon), (0,_define_property/* default */.Z)(_obj, (Button_module_default())["no-text"], !children), _obj)),
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                className: (Button_module_default()).icon,
                name: icon
            }),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Button_module_default()).text,
                children: children
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/shared/components/Button/index.js


// EXTERNAL MODULE: ./src/shared/components/Container/Container.module.scss
var Container_module = __webpack_require__(64949);
var Container_module_default = /*#__PURE__*/__webpack_require__.n(Container_module);
;// CONCATENATED MODULE: ./src/shared/components/Container/Container.jsx



var Container = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Container_module_default()).container, className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Container/index.js


// EXTERNAL MODULE: ./src/shared/components/DetailsBlock/DetailsBlock.module.scss
var DetailsBlock_module = __webpack_require__(23777);
var DetailsBlock_module_default = /*#__PURE__*/__webpack_require__.n(DetailsBlock_module);
;// CONCATENATED MODULE: ./src/shared/components/DetailsBlock/DetailsBlock.jsx



var DetailsBlock = function(param) {
    var items = param.items, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: items.map(function(item) {
            if (item.text) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (DetailsBlock_module_default()).details,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                        color: "grey",
                        uppercase: true,
                        className: (DetailsBlock_module_default()).label,
                        children: item.label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                        color: "dark",
                        appearance: "bold",
                        className: (DetailsBlock_module_default()).text,
                        children: item.text
                    })
                ]
            }, item.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/DetailsBlock/index.js


// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/shared/components/Typography/index.js + 19 modules
var Typography = __webpack_require__(6271);
// EXTERNAL MODULE: ./src/shared/components/DownloadFile/DownloadFile.module.scss
var DownloadFile_module = __webpack_require__(70686);
var DownloadFile_module_default = /*#__PURE__*/__webpack_require__.n(DownloadFile_module);
;// CONCATENATED MODULE: ./src/shared/components/DownloadFile/DownloadFile.jsx






var DownloadFile = function(param) {
    var _as = param.as, as = _as === void 0 ? "span" : _as, file = param.file, _icon = param.icon, icon = _icon === void 0 ? "download" : _icon, label = param.label, _color = param.color, color = _color === void 0 ? "dark" : _color, className = param.className;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref;
    var href = (ref = file === null || file === void 0 ? void 0 : file.url) !== null && ref !== void 0 ? ref : "";
    if (!href) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: href,
        className: (DownloadFile_module_default()).download,
        target: "_blank",
        rel: "noreferrer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                className: (DownloadFile_module_default()).icon,
                name: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                className: classnames_default()(className, (DownloadFile_module_default()).element),
                color: color,
                as: as,
                children: label || t("download")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/shared/components/DownloadFile/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
;// CONCATENATED MODULE: ./src/shared/components/ErrorBoundary/ErrorBoundary.jsx





var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, _Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.log({
                    error: error,
                    errorInfo: errorInfo
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) {
                    return null;
                }
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(_) {
                return {
                    hasError: true
                };
            }
        }
    ]);
    return ErrorBoundary;
}(react.Component);

;// CONCATENATED MODULE: ./src/shared/components/ErrorBoundary/index.js


;// CONCATENATED MODULE: ./src/shared/components/Image/ImageLite.jsx


var ImageLite = function(param) {
    var image = param.image, className = param.className, fallback = param.fallback;
    var ref = (0,react.useState)(false), failed = ref[0], setFailed = ref[1];
    var ref1;
    var alternativeText = (ref1 = image === null || image === void 0 ? void 0 : image.alternativeText) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var imageUrl = (ref2 = image === null || image === void 0 ? void 0 : image.url) !== null && ref2 !== void 0 ? ref2 : "";
    var onFail = function() {
        setFailed(true);
    };
    if (failed || !image) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: fallback || null
        });
    }
    return(// eslint-disable-next-line @next/next/no-img-element
    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        onError: onFail,
        className: className,
        src: imageUrl,
        alt: alternativeText
    }));
};

;// CONCATENATED MODULE: ./src/shared/components/Image/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var src_extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./src/components/Forms/index.js + 17 modules
var Forms = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/shared/components/Inputs/InputCheckbox/InputCheckbox.module.scss
var InputCheckbox_module = __webpack_require__(47805);
var InputCheckbox_module_default = /*#__PURE__*/__webpack_require__.n(InputCheckbox_module);
;// CONCATENATED MODULE: ./src/shared/components/Inputs/InputCheckbox/InputCheckbox.jsx









var InputCheckbox = function(param) {
    var type = param.type, name = param.name, label = param.label;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useContext)(Forms/* FormContent */.fb), onChange = ref.onChange, getInputValue = ref.getInputValue, getInputError = ref.getInputError;
    var value = getInputValue(name);
    var errors = getInputError(name);
    var updateHandler = function(e) {
        onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e), {
            target: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e.target), {
                name: name,
                value: e.target.checked
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((InputCheckbox_module_default())["input-type"], (InputCheckbox_module_default())["input-type--".concat(type)]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            className: (InputCheckbox_module_default()).label,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: type,
                    name: name,
                    className: (InputCheckbox_module_default()).checkbox,
                    checked: value,
                    onChange: updateHandler
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classnames_default()((InputCheckbox_module_default()).checkmark, (0,_define_property/* default */.Z)({}, (InputCheckbox_module_default())["checkmark--required"], errors === null || errors === void 0 ? void 0 : errors.required))
                }),
                t(label)
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Inputs/InputCheckbox/index.js


// EXTERNAL MODULE: ./src/shared/components/Inputs/InputEmail/InputEmail.module.scss
var InputEmail_module = __webpack_require__(59901);
var InputEmail_module_default = /*#__PURE__*/__webpack_require__.n(InputEmail_module);
;// CONCATENATED MODULE: ./src/shared/components/Inputs/InputEmail/InputEmail.jsx







var InputEmail = function(param) {
    var type = param.type, name = param.name, placeholder = param.placeholder;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useContext)(Forms/* FormContent */.fb), onChange = ref.onChange, onValidate = ref.onValidate, getInputValue = ref.getInputValue, getInputError = ref.getInputError;
    var value = getInputValue(name);
    var errors = getInputError(name);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((InputEmail_module_default())["input-type"], (InputEmail_module_default())["input-type--".concat(type)]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: type,
                name: name,
                placeholder: t(placeholder),
                className: classnames_default()((InputEmail_module_default()).input, (0,_define_property/* default */.Z)({}, (InputEmail_module_default())["has-error"], (errors === null || errors === void 0 ? void 0 : errors.required) || (errors === null || errors === void 0 ? void 0 : errors.pattern))),
                value: value,
                onChange: onChange,
                onBlur: onValidate
            }),
            (errors === null || errors === void 0 ? void 0 : errors.required) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (InputEmail_module_default()).error,
                children: t("error_required")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Inputs/InputEmail/index.js


// EXTERNAL MODULE: ./node_modules/react-hook-mask/dist/esm/index.js + 5 modules
var esm = __webpack_require__(90529);
// EXTERNAL MODULE: ./src/shared/components/Inputs/InputTel/InputTel.module.scss
var InputTel_module = __webpack_require__(59340);
var InputTel_module_default = /*#__PURE__*/__webpack_require__.n(InputTel_module);
;// CONCATENATED MODULE: ./src/shared/components/Inputs/InputTel/InputTel.jsx










var mask = "+38(0XX)XXX-XX-XX";
var maskGenerator = {
    rules: new Map([
        [
            "X",
            /\d/
        ]
    ]),
    generateMask: function() {
        return mask;
    }
};
var InputTel = function(param) {
    var type = param.type, name = param.name, placeholder = param.placeholder;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useContext)(Forms/* FormContent */.fb), onChange = ref.onChange, onValidate = ref.onValidate, getInputValue = ref.getInputValue, getInputError = ref.getInputError;
    var value = getInputValue(name);
    var errors = getInputError(name);
    var updateHandler = function(e) {
        if (e) {
            onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e), {
                target: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e.target), {
                    name: name,
                    value: "380".concat(e)
                })
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((InputTel_module_default())["input-type"], (InputTel_module_default())["input-type--".concat(type)]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MaskedInput */.CX, {
                type: type,
                name: name,
                placeholder: t(placeholder),
                className: classnames_default()((InputTel_module_default()).input, (0,_define_property/* default */.Z)({}, (InputTel_module_default())["has-error"], (errors === null || errors === void 0 ? void 0 : errors.required) || (errors === null || errors === void 0 ? void 0 : errors.pattern))),
                value: value,
                onChange: updateHandler,
                onBlur: onValidate,
                maskGenerator: maskGenerator
            }),
            (errors === null || errors === void 0 ? void 0 : errors.required) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (InputTel_module_default()).error,
                children: t("error_required")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Inputs/InputTel/index.js


// EXTERNAL MODULE: ./src/shared/components/Inputs/InputText/InputText.module.scss
var InputText_module = __webpack_require__(84370);
var InputText_module_default = /*#__PURE__*/__webpack_require__.n(InputText_module);
;// CONCATENATED MODULE: ./src/shared/components/Inputs/InputText/InputText.jsx







var InputText = function(param) {
    var type = param.type, name = param.name, placeholder = param.placeholder;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useContext)(Forms/* FormContent */.fb), onChange = ref.onChange, onValidate = ref.onValidate, getInputValue = ref.getInputValue, getInputError = ref.getInputError;
    var value = getInputValue(name);
    var errors = getInputError(name);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((InputText_module_default())["input-type"], (InputText_module_default())["input-type--".concat(type)]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: type,
                name: name,
                placeholder: t(placeholder),
                className: classnames_default()((InputText_module_default()).input, (0,_define_property/* default */.Z)({}, (InputText_module_default())["has-error"], (errors === null || errors === void 0 ? void 0 : errors.required) || (errors === null || errors === void 0 ? void 0 : errors.pattern))),
                value: value,
                onChange: onChange,
                onBlur: onValidate
            }),
            (errors === null || errors === void 0 ? void 0 : errors.required) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (InputText_module_default()).error,
                children: t("error_required")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Inputs/InputText/index.js


;// CONCATENATED MODULE: ./src/shared/components/Inputs/InputType.jsx







var DefaultInput = function() {
    return null;
};
var TYPE_INPUT_MAPPING = {
    checkbox: InputCheckbox,
    text: InputText,
    email: InputEmail,
    tel: InputTel,
    default: DefaultInput
};
var InputType = function(_param) {
    var input = (0,src_extends/* default */.Z)({}, _param);
    var InputItem = TYPE_INPUT_MAPPING[input.type] || TYPE_INPUT_MAPPING.default;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputItem, (0,_object_spread/* default */.Z)({}, input));
};

;// CONCATENATED MODULE: ./src/shared/components/Inputs/index.js


// EXTERNAL MODULE: ./src/shared/components/LazyRenderingButton/index.js + 3 modules
var LazyRenderingButton = __webpack_require__(41141);
// EXTERNAL MODULE: ./src/shared/components/ModalWrapper/ModalWrapper.module.scss
var ModalWrapper_module = __webpack_require__(11241);
var ModalWrapper_module_default = /*#__PURE__*/__webpack_require__.n(ModalWrapper_module);
;// CONCATENATED MODULE: ./src/shared/components/ModalWrapper/ModalWrapper.jsx




var ModalWrapper = function(param) {
    var children = param.children, appearance = param.appearance, onCloseModal = param.onCloseModal;
    var onPrevent = function(e) {
        return e.stopPropagation();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ModalWrapper_module_default()).wrapper,
            onClick: onCloseModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((ModalWrapper_module_default()).inner, (ModalWrapper_module_default())[appearance]),
                onClick: onPrevent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                        className: (ModalWrapper_module_default()).close,
                        onClick: onCloseModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            className: (ModalWrapper_module_default())["close-icon"],
                            name: "close",
                            theme: "grey"
                        })
                    }),
                    children
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/ModalWrapper/index.js


// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
// EXTERNAL MODULE: ./src/shared/components/NewsElements/Article/Article.module.scss
var Article_module = __webpack_require__(80664);
var Article_module_default = /*#__PURE__*/__webpack_require__.n(Article_module);
;// CONCATENATED MODULE: ./src/shared/components/NewsElements/Article/Article.jsx






var DEFAULT_VISIBLE_LETTERS = 100;
var Article = function(param) {
    var item = param.item, className = param.className;
    var locale = (0,router.useRouter)().locale;
    var date = (0,react.useMemo)(function() {
        return (0,utils/* formatDate */.p6)(item === null || item === void 0 ? void 0 : item.date, locale);
    }, [
        item.date,
        locale
    ]);
    var truncatedTitle = (0,react.useMemo)(function() {
        var ref;
        var title = (ref = item === null || item === void 0 ? void 0 : item.title) !== null && ref !== void 0 ? ref : "";
        return (0,utils/* truncateText */.aF)(title, DEFAULT_VISIBLE_LETTERS);
    }, [
        item === null || item === void 0 ? void 0 : item.title
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Article_module_default()).article,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Article_module_default()).text,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                            slug: item.slug,
                            directory: "news",
                            className: (Article_module_default()).block,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                                color: "dark",
                                className: (Article_module_default()).title,
                                appearance: "bold",
                                children: truncatedTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Article_module_default()).date,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                                color: "grey",
                                children: date
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Article_module_default()).media,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLite, {
                        image: item.previewImage,
                        className: (Article_module_default()).image
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/NewsElements/Article/index.js


// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/shared/components/NewsElements/Banner/Banner.module.scss
var Banner_module = __webpack_require__(406);
var Banner_module_default = /*#__PURE__*/__webpack_require__.n(Banner_module);
;// CONCATENATED MODULE: ./src/shared/components/NewsElements/Banner/Banner.jsx









var Banner = function(param) {
    var item = param.item, className = param.className;
    var ref;
    var locale = (0,router.useRouter)().locale;
    var t = (0,translations/* useTranslation */.$)().t;
    var date = (0,react.useMemo)(function() {
        return (0,utils/* formatDate */.p6)(item.startDate, locale);
    }, [
        item.startDate,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
            slug: item === null || item === void 0 ? void 0 : (ref = item.course) === null || ref === void 0 ? void 0 : ref.slug,
            directory: "programs",
            className: (Banner_module_default()).block,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Banner_module_default()).card,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Banner_module_default()).text,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading4 */.k8, {
                                color: "light",
                                className: (Banner_module_default()).heading,
                                children: item.heading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                color: "light",
                                className: (Banner_module_default()).description,
                                value: item.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                                color: "light",
                                className: (Banner_module_default()).date,
                                appearance: "bold",
                                children: date
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Banner_module_default()).button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RenderIf, {
                            viewMode: ViewMode/* VIEW_MODES.DESKTOP */.nY.DESKTOP,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Banner_module_default()).arrow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        className: (Banner_module_default()).icon,
                                        name: "arrow_right"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                                    color: "light",
                                    className: (Banner_module_default()).more,
                                    appearance: "bigger",
                                    children: t("more")
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/NewsElements/Banner/index.js


// EXTERNAL MODULE: ./src/shared/components/NewsElements/HighlightedArticle/HighlightedArticle.module.scss
var HighlightedArticle_module = __webpack_require__(84995);
var HighlightedArticle_module_default = /*#__PURE__*/__webpack_require__.n(HighlightedArticle_module);
;// CONCATENATED MODULE: ./src/shared/components/NewsElements/HighlightedArticle/HighlightedArticle.jsx








var HighlightedArticle = function(param) {
    var item = param.item;
    var locale = (0,router.useRouter)().locale;
    var t = (0,translations/* useTranslation */.$)().t;
    var date = (0,react.useMemo)(function() {
        return (0,utils/* formatDate */.p6)(item === null || item === void 0 ? void 0 : item.date, locale);
    }, [
        item.date,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HighlightedArticle_module_default()).article,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLite, {
                image: item.previewImage,
                className: (HighlightedArticle_module_default()).image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HighlightedArticle_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                        color: "light",
                        className: (HighlightedArticle_module_default()).date,
                        appearance: "bold",
                        children: date
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HighlightedArticle_module_default()).card,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HighlightedArticle_module_default()).text,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                        color: "light",
                                        className: (HighlightedArticle_module_default()).title,
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderIf, {
                                        viewMode: ViewMode/* VIEW_MODES.DESKTOP */.nY.DESKTOP,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                                            color: "light",
                                            className: (HighlightedArticle_module_default()).description,
                                            children: item.description
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageLink, {
                                slug: item.slug,
                                directory: "news",
                                className: (HighlightedArticle_module_default()).link,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (HighlightedArticle_module_default()).arrow,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                            className: (HighlightedArticle_module_default()).icon,
                                            name: "large_arrow_right"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                                        color: "light",
                                        appearance: "bold",
                                        children: t("more")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/shared/components/NewsElements/HighlightedArticle/index.js


;// CONCATENATED MODULE: ./src/shared/components/NewsElements/NewsItems/NewsItems.jsx




var TYPE_CARD_MAPPING = {
    banner: Banner,
    article: Article,
    default: Article
};
var NewsItems = function(param) {
    var items = param.items, className = param.className, limit = param.limit;
    var slicedItems = (0,react.useMemo)(function() {
        return items.slice(0, limit);
    }, [
        items,
        limit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: slicedItems.map(function(item) {
            var Card = TYPE_CARD_MAPPING[item.type] || TYPE_CARD_MAPPING.default;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                item: item
            }, "".concat(item.type, "_").concat(item.id, "_").concat(item.title));
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/NewsElements/NewsItems/index.js


;// CONCATENATED MODULE: ./src/shared/components/NewsElements/index.js





// EXTERNAL MODULE: ./src/shared/components/OrderedList/OrderedList.module.scss
var OrderedList_module = __webpack_require__(76658);
var OrderedList_module_default = /*#__PURE__*/__webpack_require__.n(OrderedList_module);
;// CONCATENATED MODULE: ./src/shared/components/OrderedList/OrderedList.jsx





var OrderedList = function(param) {
    var items = param.items, appearance = param.appearance, className = param.className;
    var formatCounter = function(number) {
        return number > 9 ? number : "0".concat(number);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((OrderedList_module_default()).wrapper, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            className: (OrderedList_module_default()).list,
            children: items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: (OrderedList_module_default())["list-item"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading6 */.Cd, {
                            color: "brand",
                            as: "span",
                            plain: true,
                            children: formatCounter(index + 1)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                            as: "p",
                            className: classnames_default()((OrderedList_module_default()).title, (OrderedList_module_default())[appearance]),
                            children: item.title
                        }),
                        item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                            color: "dark",
                            value: item.description,
                            className: (OrderedList_module_default()).description
                        })
                    ]
                }, item.id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/OrderedList/index.js


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/shared/components/PageLink/getLinkParams.js
var getLinkParams = function(directory, slug) {
    var slugParamsMapping = {
        home: {
            pathname: "/"
        },
        teachers: {
            pathname: "/team/teachers"
        }
    };
    var directoryParamsMapping = {
        programs: {
            pathname: "/programs/[slug]",
            query: {
                slug: slug
            }
        },
        events: {
            pathname: "/events/[slug]",
            query: {
                slug: slug
            }
        },
        news: {
            pathname: "/news/[slug]",
            query: {
                slug: slug
            }
        },
        newsCategory: {
            pathname: "/news/category/[slug]",
            query: {
                slug: slug
            }
        },
        projects: {
            pathname: "/graduates/projects/[slug]",
            query: {
                slug: slug
            }
        },
        teachers: {
            pathname: "/team/teachers/[slug]",
            query: {
                slug: slug
            }
        }
    };
    if (directory) {
        return directoryParamsMapping[directory];
    }
    return slugParamsMapping[slug] ? slugParamsMapping[slug] : {
        pathname: "/[slug]",
        query: {
            slug: slug
        }
    };
};

;// CONCATENATED MODULE: ./src/shared/components/PageLink/PageLink.jsx



var PageLink = function(param) {
    var children = param.children, directory = param.directory, slug = param.slug, link = param.link, className = param.className, _target = param.target, target = _target === void 0 ? "_self" : _target;
    var linkOptions = "";
    if (slug) {
        linkOptions = getLinkParams(directory, slug);
    }
    if (link) {
        var absolute = link === null || link === void 0 ? void 0 : link.includes("https");
        if (absolute) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: link,
                className: className,
                target: target,
                rel: "noreferrer",
                children: children
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: className,
                children: children
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: linkOptions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: className,
            children: children
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/PageLink/index.js


// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./src/shared/components/Portal/Portal.module.scss
var Portal_module = __webpack_require__(88959);
var Portal_module_default = /*#__PURE__*/__webpack_require__.n(Portal_module);
;// CONCATENATED MODULE: ./src/shared/components/Portal/Portal.jsx





var Portal = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, children = param.children;
    var rootElement = document.querySelector("#portals-root");
    (0,react.useLayoutEffect)(function() {
        document.body.classList.add("is-frozen");
        return function() {
            document.body.classList.remove("is-frozen");
        };
    });
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Portal_module_default()).portal, className),
        children: children
    }), rootElement);
};

;// CONCATENATED MODULE: ./src/shared/components/Portal/index.js


// EXTERNAL MODULE: ./src/shared/components/Poster/Poster.jsx
var Poster = __webpack_require__(81072);
;// CONCATENATED MODULE: ./src/shared/components/Poster/index.js


;// CONCATENATED MODULE: ./src/shared/components/Redirect/Redirect.jsx


var Redirect = function(param) {
    var path = param.path;
    var push = useRouter().push;
    useEffect(function() {
        push(path);
    }, [
        path,
        push
    ]);
    return null;
};

;// CONCATENATED MODULE: ./src/shared/components/Redirect/index.js


;// CONCATENATED MODULE: ./src/shared/components/RenderIf/RenderIf.jsx

var RenderIf = function(param) {
    var children = param.children, viewMode = param.viewMode;
    var mode = (0,ViewMode/* useViewMode */.mJ)().mode;
    if (viewMode === mode) {
        return children;
    }
    return null;
};

;// CONCATENATED MODULE: ./src/shared/components/RenderIf/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/shared/components/RichString/RichString.modifiers.js

var addBreak = function(value) {
    if ((0,_to_consumable_array/* default */.Z)(value.matchAll(/{{break}}/g)).length > 0) {
        return value.replaceAll("{{break}}", "<br/>");
    }
    return value;
};
var addBold = function(value) {
    if ((0,_to_consumable_array/* default */.Z)(value.matchAll(/{{style:bold}}(.*?){{\/style:bold}}/g)).length > 0) {
        return value.replaceAll("{{style:bold}}", "<strong>").replaceAll("{{/style:bold}}", "</strong>");
    }
    return value;
};

;// CONCATENATED MODULE: ./src/shared/components/RichString/RichString.jsx



var richStringModifier = (0,utils/* pipe */.zG)(addBreak, addBold);
var RichString = function(param) {
    var value = param.value;
    try {
        var result = richStringModifier(value);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: result
            }
        });
    } catch (e) {
        return value;
    }
};

;// CONCATENATED MODULE: ./src/shared/components/RichString/index.js


// EXTERNAL MODULE: ./src/shared/components/SiteLogo/index.js + 1 modules
var SiteLogo = __webpack_require__(21472);
// EXTERNAL MODULE: ./src/shared/components/StickableContent/StickableContent.module.scss
var StickableContent_module = __webpack_require__(95064);
var StickableContent_module_default = /*#__PURE__*/__webpack_require__.n(StickableContent_module);
;// CONCATENATED MODULE: ./src/shared/components/StickableContent/StickableContent.jsx


var StickableContent = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (StickableContent_module_default()).sticky,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/shared/components/StickableContent/index.js


// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/shared/components/SwiperLayout/SwiperLayout.module.scss
var SwiperLayout_module = __webpack_require__(88288);
var SwiperLayout_module_default = /*#__PURE__*/__webpack_require__.n(SwiperLayout_module);
;// CONCATENATED MODULE: ./src/shared/components/SwiperLayout/SwiperLayout.jsx





var SwiperLayout = function(param) {
    var children = param.children, spaceBetween = param.spaceBetween, slidesPerView = param.slidesPerView, slidesPerGroup = param.slidesPerGroup, paginationWrapper = param.paginationWrapper, prevRef = param.prevRef, nextRef = param.nextRef, watchOverflow = param.watchOverflow, slidesOffsetAfter = param.slidesOffsetAfter, _loop = param.loop, loop = _loop === void 0 ? false : _loop, _observer = param.observer, observer = _observer === void 0 ? true : _observer;
    var ref = (0,react.useState)(null), _ = ref[0], setInit = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
        watchOverflow: watchOverflow,
        observer: observer,
        modules: [
            swiper_esm/* Navigation */.W_,
            swiper_esm/* Pagination */.tl
        ],
        navigation: {
            prevEl: prevRef.current,
            nextEl: nextRef.current
        },
        pagination: {
            el: ".".concat(paginationWrapper),
            clickable: true,
            type: "fraction",
            renderFraction: function(currentClass, totalClass) {
                return '<span class="'.concat(currentClass, " ").concat((SwiperLayout_module_default())["pagination-current"], '"></span><span class="').concat(totalClass, '"></span>');
            }
        },
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        slidesPerGroup: slidesPerGroup,
        slidesOffsetAfter: slidesOffsetAfter,
        onInit: function() {
            setInit(true);
        },
        onBeforeInit: function(swiper) {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
        },
        loop: loop,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: children
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/SwiperLayout/index.js


// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.hooks.js
var Tabs_hooks = __webpack_require__(60419);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.module.scss
var Tabs_module = __webpack_require__(64283);
var Tabs_module_default = /*#__PURE__*/__webpack_require__.n(Tabs_module);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.Provider.js
var Tabs_Provider = __webpack_require__(11742);
;// CONCATENATED MODULE: ./src/shared/components/Tabs/Tabs.jsx










var Tabs = function(param) {
    var appearance = param.appearance, tabType = param.tabType, className = param.className;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,Tabs_hooks/* useTabsState */.n)(), tabs = ref.tabs, activeTab = ref.activeTab, activeTabIndex = ref.activeTabIndex, setActiveTab = ref.setActiveTab, tabsEnabled = ref.tabsEnabled;
    var isMobile = (0,ViewMode/* useViewMode */.mJ)().isMobile;
    var ref1 = (0,react.useState)(0), tabUnderlineWidth = ref1[0], setTabUnderlineWidth = ref1[1];
    var ref2 = (0,react.useState)(0), tabUnderlineLeft = ref2[0], setTabUnderlineLeft = ref2[1];
    var tabsRef = (0,react.useRef)([]);
    var moveLine = (0,react.useCallback)(function(i) {
        return function(el) {
            return tabsRef.current[i] = el;
        };
    }, []);
    (0,react.useEffect)(function() {
        var setTabPosition = function() {
            var currentTab = tabsRef.current[activeTabIndex];
            var ref;
            setTabUnderlineLeft((ref = currentTab === null || currentTab === void 0 ? void 0 : currentTab.offsetLeft) !== null && ref !== void 0 ? ref : 0);
            var ref1;
            setTabUnderlineWidth((ref1 = currentTab === null || currentTab === void 0 ? void 0 : currentTab.clientWidth) !== null && ref1 !== void 0 ? ref1 : 0);
        };
        setTabPosition();
        window.addEventListener("resize", setTabPosition);
        return function() {
            return window.removeEventListener("resize", setTabPosition);
        };
    }, [
        activeTabIndex
    ]);
    var handleClickOnTab = (0,react.useCallback)(function(index, tab) {
        return function() {
            setActiveTab(tab);
        };
    }, [
        setActiveTab
    ]);
    if (!tabsEnabled) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((Tabs_module_default()).tabs, (Tabs_module_default())[tabType], className),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: classnames_default()((Tabs_module_default())["tabs-list"], (Tabs_module_default())[appearance]),
                children: [
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Tabs_module_default()).underline,
                        style: {
                            left: tabUnderlineLeft,
                            width: tabUnderlineWidth
                        }
                    }),
                    tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            ref: moveLine(index),
                            className: classnames_default()((Tabs_module_default())["tabs-item"], (0,_define_property/* default */.Z)({}, (Tabs_module_default())["tabs-item-active"], tab === activeTab)),
                            onClick: handleClickOnTab(index, tab),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                                color: "grey",
                                children: tab === Tabs_Provider/* DEFAULT_TAB_ID */.$E ? t("All") : t(tab)
                            })
                        }, tab);
                    }),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Tabs_module_default()).underline,
                        style: {
                            left: tabUnderlineLeft,
                            width: tabUnderlineWidth
                        }
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Tabs/index.js


// EXTERNAL MODULE: ./src/shared/components/Tags/Tags.module.scss
var Tags_module = __webpack_require__(46837);
var Tags_module_default = /*#__PURE__*/__webpack_require__.n(Tags_module);
;// CONCATENATED MODULE: ./src/shared/components/Tags/TagItem.jsx





var TagItem = function(param) {
    var tag = param.tag, activeTag = param.activeTag;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
        slug: tag.slug,
        directory: "newsCategory",
        className: (Tags_module_default()).link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
            as: "span",
            color: "grey",
            className: classnames_default()((Tags_module_default()).tag, (0,_define_property/* default */.Z)({}, (Tags_module_default()).active, activeTag)),
            uppercase: true,
            children: tag.title
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Tags/AllTags.jsx





var AllTags = function(param) {
    var tags = param.tags, activeTag = param.activeTag;
    var t = (0,translations/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Tags_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading6 */.Cd, {
                className: (Tags_module_default()).heading,
                color: "dark",
                appearance: "bold",
                children: t("allTags")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Tags_module_default()).tags,
                children: tags.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagItem, {
                        tag: tag,
                        activeTag: tag.slug === activeTag
                    }, tag.id);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
;// CONCATENATED MODULE: ./src/shared/components/Tags/PopularTags.jsx









var PopularTags = function(param) {
    var tags = param.tags, activeTag = param.activeTag;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,hooks/* useToggle */.OT)(), opened = ref.opened, onOpen = ref.onOpen, onClose = ref.onClose;
    var popularTags = (0,react.useMemo)(function() {
        return tags.filter(function(tag) {
            return tag.popular;
        });
    }, [
        tags
    ]);
    (0,react.useEffect)(function() {
        router_default().events.on("routeChangeComplete", onClose);
        return function() {
            router_default().events.off("routeChangeComplete", onClose);
        };
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Tags_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                as: "p",
                className: (Tags_module_default()).title,
                color: "grey",
                appearance: "bigger",
                children: t("popularTags")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Tags_module_default()).tags,
                children: popularTags.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagItem, {
                        tag: tag,
                        activeTag: tag.slug === activeTag
                    }, tag.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                onClick: onOpen,
                className: (Tags_module_default()).button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (Tags_module_default()).arrow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Paragraph */.nv, {
                            as: "p",
                            color: "brand",
                            appearance: "bigger",
                            className: (Tags_module_default()).label,
                            children: t("allTags")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            className: (Tags_module_default()).icon,
                            name: "arrow_right"
                        })
                    ]
                })
            }),
            opened && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {
                onCloseModal: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllTags, {
                    tags: tags,
                    activeTag: activeTag
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/shared/components/Tags/index.js



// EXTERNAL MODULE: ./src/shared/components/YoutubeVideo/YoutubeVideo.module.scss
var YoutubeVideo_module = __webpack_require__(26731);
var YoutubeVideo_module_default = /*#__PURE__*/__webpack_require__.n(YoutubeVideo_module);
;// CONCATENATED MODULE: ./src/shared/components/YoutubeVideo/YoutubeVideo.jsx



var YoutubeVideo = function(param) {
    var className = param.className, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((YoutubeVideo_module_default()).wrapper, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            className: (YoutubeVideo_module_default()).player,
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/".concat(id),
            title: "YouTube video player",
            frameBorder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true
        })
    });
};

;// CONCATENATED MODULE: ./src/shared/components/YoutubeVideo/index.js


;// CONCATENATED MODULE: ./src/shared/components/index.js































/***/ }),

/***/ 65202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zz": function() { return /* reexport */ PageDataProvider; },
  "M": function() { return /* reexport */ useCollectedData; },
  "Vi": function() { return /* reexport */ usePageData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/shared/contexts/PageData/PageData.context.js

var defaultValue = {
    data: {
        seo: {},
        content: [],
        footer: [],
        hero: []
    },
    collectedData: {},
    templatedData: {
        hero: [],
        content: []
    }
};
var PageDataContext = /*#__PURE__*/ (0,react.createContext)(defaultValue);

;// CONCATENATED MODULE: ./src/shared/contexts/PageData/PageData.hooks.js





function usePageData() {
    var data = (0,react.useContext)(PageDataContext).data;
    return data !== null && data !== void 0 ? data : defaultValue.data;
}
function useCollectedData(builtWidgetId, fields) {
    var collectedData = (0,react.useContext)(PageDataContext).collectedData;
    return (0,react.useMemo)(function() {
        return fields.reduce(function(acc, field) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, field.name, (ref = collectedData === null || collectedData === void 0 ? void 0 : collectedData["".concat(builtWidgetId, ".").concat(field.name)]) !== null && ref !== void 0 ? ref : field.defaultValue));
        }, {});
    }, [
        builtWidgetId,
        collectedData,
        fields
    ]);
}

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/shared/contexts/PageData/PageData.provider.jsx


function PageDataProvider(param) {
    var children = param.children, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageDataContext.Provider, {
        value: value,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/shared/contexts/PageData/index.js




/***/ }),

/***/ 87367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p$": function() { return /* reexport */ useCollectedNewsRender; },
  "Zf": function() { return /* reexport */ useFormSubmit; },
  "VE": function() { return /* reexport */ useOffsetScroll; },
  "O3": function() { return /* reexport */ useOutsideClick; },
  "OT": function() { return /* reexport */ useToggle; },
  "nf": function() { return /* reexport */ useWindowScrollListener; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/cms/index.js + 3 modules
var cms = __webpack_require__(49204);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
;// CONCATENATED MODULE: ./src/shared/hooks/useCollectedNewsRender.js









var FETCH_INITIAL_PAGE = 2;
var PAGESIZE = 5;
var useCollectedNewsRender = function(param) {
    var payload = param.payload, widgetNumber = param.widgetNumber;
    var ref = (0,router.useRouter)(), query = ref.query, locale = ref.locale;
    var ref1;
    var courseBanner = (0,react.useMemo)(function() {
        return (ref1 = payload === null || payload === void 0 ? void 0 : payload.courseBanner) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        payload
    ]);
    var ref2;
    var articleSlug = (0,react.useMemo)(function() {
        return (ref2 = query === null || query === void 0 ? void 0 : query.slug) !== null && ref2 !== void 0 ? ref2 : null;
    }, [
        query === null || query === void 0 ? void 0 : query.slug
    ]);
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)(widgetNumber, payload.id);
    var ref3 = (0,PageData/* useCollectedData */.M)(instanceId, [
        {
            name: "articles",
            defaultValue: []
        },
        {
            name: "article-categories",
            defaultValue: []
        }, 
    ]), articles = ref3.articles, articleCategories = ref3["article-categories"];
    var ref4 = (0,react.useMemo)(function() {
        return articleCategories.filter(function(param) {
            var slug = param.slug;
            return slug === articleSlug;
        });
    }, [
        articleCategories,
        articleSlug
    ]), activeCategory = ref4[0];
    var ref5 = (0,react.useState)([]), feed = ref5[0], setFeed = ref5[1];
    var ref6 = (0,react.useState)(new Date()), date = ref6[0], setDate = ref6[1];
    var ref7 = (0,react.useState)(PAGESIZE), limit = ref7[0], setLimit = ref7[1];
    var ref8 = (0,react.useState)(FETCH_INITIAL_PAGE), fetchPage = ref8[0], setfetchPage = ref8[1];
    var visibleBanners = (0,react.useMemo)(function() {
        return courseBanner.filter(function(course) {
            return course.courseBannerPosition <= limit;
        });
    }, [
        limit,
        courseBanner
    ]);
    (0,react.useEffect)(function() {
        var item = (0,utils/* buildFeed */.sW)({
            articles: articles
        });
        setLimit(PAGESIZE);
        setFeed(item);
    }, [
        articleSlug,
        articles
    ]);
    var feedWithBanners = (0,react.useMemo)(function() {
        return (0,utils/* mergeWithBanners */.d9)((0,_to_consumable_array/* default */.Z)(feed), visibleBanners, "courseBannerPosition");
    }, [
        feed,
        visibleBanners
    ]);
    (0,react.useEffect)(function() {
        if (feedWithBanners.length <= limit) {
            var collectedDataRender = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var nextArticles, ref, temporaryFeed;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (!articleSlug) {
                                    _ctx.next = 6;
                                    break;
                                }
                                _ctx.next = 3;
                                return (0,cms/* fetchAPI */.I)("/articles", {
                                    sort: "date:DESC",
                                    populate: {
                                        articleCategories: {
                                            populate: "deep,1"
                                        },
                                        previewImage: "*"
                                    },
                                    filters: {
                                        articleCategories: {
                                            slug: {
                                                $in: articleSlug
                                            }
                                        },
                                        date: {
                                            $lte: date
                                        }
                                    },
                                    pagination: {
                                        page: fetchPage,
                                        pageSize: PAGESIZE
                                    },
                                    locale: locale
                                });
                            case 3:
                                _ctx.t0 = _ctx.sent;
                                _ctx.next = 9;
                                break;
                            case 6:
                                _ctx.next = 8;
                                return (0,cms/* fetchAPI */.I)("/articles", {
                                    sort: "date:DESC",
                                    populate: {
                                        previewImage: "*"
                                    },
                                    filters: {
                                        date: {
                                            $lte: date
                                        }
                                    },
                                    pagination: {
                                        page: fetchPage,
                                        pageSize: PAGESIZE
                                    },
                                    locale: locale
                                });
                            case 8:
                                _ctx.t0 = _ctx.sent;
                            case 9:
                                nextArticles = _ctx.t0;
                                ;
                                temporaryFeed = (0,utils/* buildFeed */.sW)({
                                    articles: (ref = nextArticles === null || nextArticles === void 0 ? void 0 : nextArticles.data) !== null && ref !== void 0 ? ref : []
                                });
                                setFeed(function(currentFeed) {
                                    return (0,_to_consumable_array/* default */.Z)(currentFeed).concat((0,_to_consumable_array/* default */.Z)(temporaryFeed));
                                });
                                setfetchPage(function(prevPage) {
                                    return prevPage + 1;
                                });
                            case 14:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function collectedDataRender() {
                    return _ref.apply(this, arguments);
                };
            }();
            collectedDataRender();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        limit
    ]);
    var isCompleted = (0,react.useMemo)(function() {
        return feedWithBanners.length < limit;
    }, [
        feedWithBanners.length,
        limit
    ]);
    var renderNext = (0,react.useCallback)(function() {
        if (!isCompleted) {
            setLimit(function(limit) {
                return limit + PAGESIZE;
            });
        }
    }, [
        isCompleted
    ]);
    return {
        feed: feedWithBanners,
        isCompleted: isCompleted,
        renderNext: renderNext,
        limit: limit,
        articleCategories: articleCategories,
        activeCategory: activeCategory
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/shared/hooks/useFormSubmit.js




var useFormSubmit = function() {
    var ref = (0,react.useState)(false), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(false), success = ref1[0], setSuccess = ref1[1];
    var ref2 = (0,react.useState)(false), pending = ref2[0], setPending = ref2[1];
    var onResetFormSubmit = (0,react.useCallback)(function() {
        setSuccess(false);
        setPending(false);
    }, []);
    var onSubmit = (0,react.useCallback)(function(param) {
        var type = param.type, data = param.data, metaData = param.metaData;
        setPending(true);
        fetch((0,cms/* getCmsUrl */.j)("/api/form-request"), {
            headers: {
                "Content-Type": "application/json"
            },
            method: "post",
            body: JSON.stringify({
                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    email: data.email
                }, metaData && {
                    metaData: metaData
                }), {
                    type: type,
                    formData: data
                })
            })
        }).then(function() {
            setSuccess(true);
        }).catch(function() {
            setError(true);
        }).finally(function() {
            setPending(false);
        });
    }, []);
    return {
        error: error,
        success: success,
        pending: pending,
        onResetFormSubmit: onResetFormSubmit,
        onSubmit: onSubmit
    };
};

;// CONCATENATED MODULE: ./src/shared/hooks/useOffsetScroll.js

var useOffsetScroll = function(param) {
    var widgetOffset = param.widgetOffset, position = param.position;
    var widgetsRoot = (0,react.useRef)(null);
    var ref;
    var targetPosition = (ref = position + widgetOffset) !== null && ref !== void 0 ? ref : 0;
    (0,react.useEffect)(function() {
        widgetsRoot.current = document.querySelector('[data-widget-root="content"]');
    }, []);
    var scrollToTarget = (0,react.useCallback)(function() {
        if (widgetsRoot.current === null) {
            return;
        }
        var targetWidget = widgetsRoot.current.querySelector('[data-widget-position="'.concat(targetPosition, '"]'));
        if (targetWidget === null) {
            return;
        }
        var scrollPosition = targetWidget.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: scrollPosition,
            left: 0,
            behavior: "smooth"
        });
    }, [
        targetPosition
    ]);
    return {
        scrollToTarget: scrollToTarget
    };
};

;// CONCATENATED MODULE: ./src/shared/hooks/useOutsideClick.js

var useOutsideClick = function(callback) {
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var handleClick = function(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener("click", handleClick, true);
        return function() {
            document.removeEventListener("click", handleClick, true);
        };
    }, [
        ref,
        callback
    ]);
    return ref;
};

;// CONCATENATED MODULE: ./src/shared/hooks/useToggle.js

var useToggle = function() {
    var ref = (0,react.useState)(false), opened = ref[0], setOpen = ref[1];
    var onOpen = (0,react.useCallback)(function() {
        return setOpen(true);
    }, []);
    var onClose = (0,react.useCallback)(function() {
        return setOpen(false);
    }, []);
    var onToggle = (0,react.useCallback)(function() {
        return setOpen(function(current) {
            return !current;
        });
    }, []);
    return {
        opened: opened,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle
    };
};

;// CONCATENATED MODULE: ./src/shared/hooks/useWindowScrollListener.js

var useWindowScrollListener = function(callback, listenToScroll) {
    (0,react.useEffect)(function() {
        if (listenToScroll) {
            window.addEventListener("scroll", callback, true);
        } else {
            window.removeEventListener("scroll", callback, true);
        }
        return function() {
            // force delete the listener after the hook is destroyed
            window.removeEventListener("scroll", callback, true);
        };
    }, [
        callback,
        listenToScroll
    ]);
    return null;
};

;// CONCATENATED MODULE: ./src/shared/hooks/index.js








/***/ }),

/***/ 63414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sW": function() { return /* reexport */ buildFeed; },
  "CT": function() { return /* reexport */ buildSortedFeed; },
  "p6": function() { return /* reexport */ formatDate; },
  "d9": function() { return /* reexport */ mergeWithBanners; },
  "Us": function() { return /* reexport */ parseYouTubeId; },
  "zG": function() { return /* reexport */ pipe; },
  "aF": function() { return /* reexport */ truncateText; }
});

// UNUSED EXPORTS: fetchSinglePageData, fetchTemplatePageData, formatTime

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/shared/utils/buildFeed/mergeWithBanners.js


var mergeWithBanners = function(feed, banners) {
    var positionBanner = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "fixedPosition";
    banners.forEach(function(promoBanner) {
        var index = promoBanner[positionBanner] - 1;
        feed.splice(index, 0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, promoBanner), {
            type: "banner"
        }));
    });
    return feed;
};
var defaultCourses = [];
var defaultEvents = [];
var mergeWithUnsortedBlocks = function(sortedFeed) {
    var courses = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultCourses, events = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultEvents;
    courses === null || courses === void 0 ? void 0 : courses.forEach(function(course, index) {
        var randomIndex = index * 3 + 2;
        sortedFeed.splice(randomIndex, 0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, course), {
            type: "course"
        }));
    });
    events === null || events === void 0 ? void 0 : events.forEach(function(event, index) {
        var randomIndex = index * 4 + 3;
        sortedFeed.splice(randomIndex, 0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event), {
            type: "event"
        }));
    });
    return sortedFeed;
};

;// CONCATENATED MODULE: ./src/shared/utils/buildFeed/buildFeed.js




var defaultArticle = [];
var buildFeed = function(param) {
    var _articles = param.articles, articles = _articles === void 0 ? defaultArticle : _articles;
    return (0,_to_consumable_array/* default */.Z)(articles.map(function(article) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, article), {
            type: "article"
        });
    }));
};
var buildSortedFeed = function(param) {
    var articles = param.articles, events = param.events, courses = param.courses;
    var sortedFeed = buildFeed({
        articles: articles
    }).sort(function(a, b) {
        return new Date(b.date) - new Date(a.date);
    });
    return mergeWithUnsortedBlocks(sortedFeed, courses, events);
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/cms/index.js + 3 modules
var cms = __webpack_require__(49204);
// EXTERNAL MODULE: ./src/features/logger/logger.utils.js
var logger_utils = __webpack_require__(88953);
;// CONCATENATED MODULE: ./src/shared/utils/fetchSinglePageData/fetchSinglePageData.js





var defaultValue = {
    seo: {},
    hero: [],
    content: [],
    footer: []
};
var fetchSinglePageData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var locale, query, debug, ref, _path, path, _defaultSlug, defaultSlug, ref1, resolvedSlug, ref2, res, currentData, _ref, seo, hero, content, footer, pageOwnData, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = param.locale, query = param.query, debug = param.debug, ref = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {}, _path = ref.path, path = _path === void 0 ? "/pages" : _path, _defaultSlug = ref.defaultSlug, defaultSlug = _defaultSlug === void 0 ? "home" : _defaultSlug;
                    ;
                    resolvedSlug = (ref1 = query === null || query === void 0 ? void 0 : query.slug) !== null && ref1 !== void 0 ? ref1 : defaultSlug;
                    _ctx.prev = 3;
                    ;
                    _ctx.next = 7;
                    return (0,cms/* fetchAPI */.I)(path, {
                        filters: {
                            slug: {
                                $eq: resolvedSlug
                            }
                        }
                    }, locale);
                case 7:
                    res = _ctx.sent;
                    currentData = res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2[0];
                    if (currentData) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.resolve({
                        data: defaultValue,
                        error: {
                            status: 204
                        },
                        debugData: debug ? {
                            scope: "Data loaded and but not provided",
                            error: {
                                status: 204,
                                message: "No data"
                            },
                            response: res
                        } : null
                    }));
                case 11:
                    _ref = currentData !== null && currentData !== void 0 ? currentData : {}, seo = _ref.seo, hero = _ref.hero, content = _ref.content, footer = _ref.footer, pageOwnData = (0,_object_without_properties/* default */.Z)(_ref, [
                        "seo",
                        "hero",
                        "content",
                        "footer"
                    ]);
                    return _ctx.abrupt("return", Promise.resolve({
                        data: {
                            seo: seo !== null && seo !== void 0 ? seo : {},
                            hero: [
                                hero === null || hero === void 0 ? void 0 : hero[0]
                            ].filter(Boolean),
                            content: content !== null && content !== void 0 ? content : [],
                            footer: footer !== null && footer !== void 0 ? footer : [],
                            pageOwnData: pageOwnData !== null && pageOwnData !== void 0 ? pageOwnData : {}
                        },
                        error: null,
                        debugData: debug ? {
                            scope: "Data loaded and provided",
                            error: null,
                            response: res
                        } : null
                    }));
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](3);
                    (0,logger_utils/* logError */.H)(_ctx.t0, {
                        scope: "fetchSinglePageData",
                        collection: "pages"
                    });
                    return _ctx.abrupt("return", Promise.resolve({
                        data: defaultValue,
                        error: {
                            status: _ctx.t0.status
                        },
                        debugData: debug ? {
                            scope: "Error caught",
                            error: {
                                status: _ctx.t0.status,
                                message: _ctx.t0.message
                            },
                            response: null
                        } : null
                    }));
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                15
            ]
        ]);
    }));
    return function fetchSinglePageData(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/shared/utils/fetchSinglePageData/index.js


;// CONCATENATED MODULE: ./src/shared/utils/fetchTemplatePageData/fetchTemplatePageData.js




var fetchTemplatePageData_defaultValue = {
    hero: [],
    content: []
};
var fetchTemplatePageData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, path) {
        var locale, debug, res, ref, currentData, ref1, hero, content;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = param.locale, debug = param.debug;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return (0,cms/* fetchAPI */.I)(path, {}, locale);
                case 4:
                    res = _ctx.sent;
                    ;
                    currentData = (ref = res === null || res === void 0 ? void 0 : res.data) !== null && ref !== void 0 ? ref : {};
                    ref1 = currentData !== null && currentData !== void 0 ? currentData : {}, hero = ref1.hero, content = ref1.content;
                    return _ctx.abrupt("return", Promise.resolve({
                        templatedData: {
                            hero: hero !== null && hero !== void 0 ? hero : [],
                            content: content !== null && content !== void 0 ? content : []
                        },
                        error: null
                    }));
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](1);
                    (0,logger_utils/* logError */.H)(_ctx.t0, {
                        scope: "fetchaTemplatePageData",
                        collection: "template"
                    });
                    return _ctx.abrupt("return", Promise.resolve({
                        templatedData: fetchTemplatePageData_defaultValue,
                        error: {
                            status: _ctx.t0.status
                        },
                        debugData: debug ? {
                            scope: "Error caught",
                            error: {
                                status: _ctx.t0.status,
                                message: _ctx.t0.message
                            },
                            response: null
                        } : null
                    }));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return function fetchTemplatePageData(_, path) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/shared/utils/fetchTemplatePageData/index.js


;// CONCATENATED MODULE: ./src/shared/utils/formatDate/formatDate.js
var formatDate = function(date, locale) {
    if (date) {
        return new Intl.DateTimeFormat(locale, {
            year: "numeric",
            month: "long",
            day: "2-digit"
        }).format(new Date(date));
    }
    return null;
};

;// CONCATENATED MODULE: ./src/shared/utils/pipe.js
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(value) {
        return fns.reduce(function(acc, fn) {
            return fn(acc);
        }, value);
    };
};

;// CONCATENATED MODULE: ./src/shared/utils/truncateText/truncateText.js
var truncateText = function(text, limit) {
    if (text) {
        return (text === null || text === void 0 ? void 0 : text.length) < limit ? text : "".concat(text === null || text === void 0 ? void 0 : text.substring(0, limit), "...");
    }
    return null;
};

;// CONCATENATED MODULE: ./src/shared/utils/videoLink/videoLink.js
// for url https://www.youtube.com/watch?v=:id
// for url https://youtu.be/:id
var parseYouTubeId = function(url) {
    if (url) {
        var urlParts = url.replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if (urlParts[2] !== undefined) {
            return urlParts[2].split(/[^0-9a-z_\-]/i)[0];
        }
    }
    return null;
};

;// CONCATENATED MODULE: ./src/shared/utils/index.js









/***/ }),

/***/ 29570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"active":"BurgerMenu_active__HvHAX","container":"BurgerMenu_container__mF1zR","content":"BurgerMenu_content__jaWJS","signin":"BurgerMenu_signin__uO0jY"};

/***/ }),

/***/ 45139:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterDesktop_wrapper__t2nn9","row":"FooterDesktop_row___kf4A","col":"FooterDesktop_col__JsLGg","links":"FooterDesktop_links__wDGo2","info":"FooterDesktop_info___J3JC","link":"FooterDesktop_link___tNbm","label":"FooterDesktop_label__5i9o1","selector":"FooterDesktop_selector__hBQtL","list":"FooterDesktop_list__adBe_","item":"FooterDesktop_item__3ErJP","title":"FooterDesktop_title__JBs9F"};

/***/ }),

/***/ 94968:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterMobile_wrapper__pvPYk","links-container":"FooterMobile_links-container__ZJ0ob","social-container":"FooterMobile_social-container__8_nVJ","links":"FooterMobile_links___oPNy","info":"FooterMobile_info__zVWwY","logo":"FooterMobile_logo__nnN16","label":"FooterMobile_label__IRbtK","brands":"FooterMobile_brands__dbVHU","ampersand":"FooterMobile_ampersand__P1kOw","credentials":"FooterMobile_credentials__oZ5Kz","right":"FooterMobile_right__0EWI5","left":"FooterMobile_left__8Be6J","interactive":"FooterMobile_interactive__3U_Xi","item":"FooterMobile_item__ckZFP","title":"FooterMobile_title__XMWIW","icon":"FooterMobile_icon__3eQww","opened":"FooterMobile_opened__0_dMW","list":"FooterMobile_list__WtQpA"};

/***/ }),

/***/ 81739:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterWidgetWrapper_wrapper__HI0pL"};

/***/ }),

/***/ 61526:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input-group":"FormApplication_input-group__vxMnL","submit":"FormApplication_submit__xH18R","arrow":"FormApplication_arrow__rBzX9","icon":"FormApplication_icon__H8Sj2","application":"FormApplication_application__4FX3L"};

/***/ }),

/***/ 27754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info":"FormInfo_info__b8Hrp","item":"FormInfo_item__Wg9iO","info-label":"FormInfo_info-label__6DRpj","info-text":"FormInfo_info-text__S58_x"};

/***/ }),

/***/ 90588:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"FormRegistration_title__iF_0e","registration":"FormRegistration_registration__4A_eQ","form":"FormRegistration_form__NmTv6","input-group":"FormRegistration_input-group__TRNC1","submit":"FormRegistration_submit__k8Kr9","arrow":"FormRegistration_arrow__9L6UK","icon":"FormRegistration_icon__J3UBN"};

/***/ }),

/***/ 59327:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormSubscription_wrapper__uRaQh","blocks":"FormSubscription_blocks__u68OH","title":"FormSubscription_title__LEbA6","subscribe":"FormSubscription_subscribe__jPhSN","form":"FormSubscription_form__GMxnw","input-group":"FormSubscription_input-group__ThCkd","circles":"FormSubscription_circles__NnQsP","arrow":"FormSubscription_arrow__K3PE3","icon":"FormSubscription_icon__WTOAV","modified":"FormSubscription_modified__p9s6V"};

/***/ }),

/***/ 66299:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DesktopHeader_wrapper__Eb1Jj","inner":"DesktopHeader_inner__yt8cf","actions":"DesktopHeader_actions__7L_Sx"};

/***/ }),

/***/ 62184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MobileHeader_wrapper__qHiLF","left":"MobileHeader_left___aSfY","right":"MobileHeader_right__4oK_f"};

/***/ }),

/***/ 99245:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"InlineLanguages_list__e_2dC","item":"InlineLanguages_item__Pdhfo","active":"InlineLanguages_active__aKrBT"};

/***/ }),

/***/ 92546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InteractiveLanguages_wrapper__yQWyC","list":"InteractiveLanguages_list__z2F0W","item":"InteractiveLanguages_item__595lv","active":"InteractiveLanguages_active__Csupp","icon":"InteractiveLanguages_icon__ACHbB","opened":"InteractiveLanguages_opened__on7wu"};

/***/ }),

/***/ 66081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"light":"LanguageSelector_light__lFo8m","dark":"LanguageSelector_dark__l80aJ"};

/***/ }),

/***/ 47417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CoursesExtraLink_wrapper__rTJqO","link":"CoursesExtraLink_link__ywzcZ","title":"CoursesExtraLink_title__9RUev","caption":"CoursesExtraLink_caption__YNlfV","button":"CoursesExtraLink_button__M9jvz","icon":"CoursesExtraLink_icon__LP3Wb"};

/***/ }),

/***/ 63309:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CoursesMenu_wrapper__Fa00J","groups":"CoursesMenu_groups__lUUDd","group":"CoursesMenu_group__mUJeF","title":"CoursesMenu_title__5pxTL","items":"CoursesMenu_items__uUl9J","paper":"CoursesMenu_paper___XG_a","divider":"CoursesMenu_divider__nNWIF","item":"CoursesMenu_item__Qwyhw","link":"CoursesMenu_link__WTDSV","subtitle":"CoursesMenu_subtitle__uzsuH","caption":"CoursesMenu_caption__QMKKd","caption-general":"CoursesMenu_caption-general__pKmZ8","buttons":"CoursesMenu_buttons__t32Ti"};

/***/ }),

/***/ 48624:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CoursesMobileMenu_wrapper__3YoIr","groups":"CoursesMobileMenu_groups__N6FzV","group":"CoursesMobileMenu_group__YOg7m","label":"CoursesMobileMenu_label__skuXp","items":"CoursesMobileMenu_items__SDrsX","item":"CoursesMobileMenu_item__UR_KU","title":"CoursesMobileMenu_title__9DUfm","caption":"CoursesMobileMenu_caption__aDWy6","buttons":"CoursesMobileMenu_buttons__jMyc8","toggle":"CoursesMobileMenu_toggle__4A6Xk","disabled":"CoursesMobileMenu_disabled__pBnv9","opened":"CoursesMobileMenu_opened__BhpXu","divider":"CoursesMobileMenu_divider__bymTC"};

/***/ }),

/***/ 90794:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownLinks_wrapper__0J4Au","link":"DropdownLinks_link__bhd48"};

/***/ }),

/***/ 97361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"HighlightedCourse_link__JafMx","title":"HighlightedCourse_title__ha9VH","button":"HighlightedCourse_button__kIWcX","icon":"HighlightedCourse_icon__buWtZ"};

/***/ }),

/***/ 80040:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__UFmD0","nav-mobile":"Navigation_nav-mobile__4tG8G"};

/***/ }),

/***/ 22563:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"NavigationItem_link__Aa1tP","title":"NavigationItem_title__GCg0w","item":"NavigationItem_item__jdUsD","overlay":"NavigationItem_overlay__qrGeQ","dropdown":"NavigationItem_dropdown__u6ZGt"};

/***/ }),

/***/ 51151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"NavigationMobileItem_title__U3ZYq","item":"NavigationMobileItem_item__lv_3a","arrow":"NavigationMobileItem_arrow__AbKkE","item-link":"NavigationMobileItem_item-link__o_x42","item-title":"NavigationMobileItem_item-title__TeQwK","container":"NavigationMobileItem_container__YFmkd","content":"NavigationMobileItem_content__8kN_j","button-back":"NavigationMobileItem_button-back__yxLFM","back":"NavigationMobileItem_back__ABIy8"};

/***/ }),

/***/ 32617:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wysiwyg":"RichTextContainer_wysiwyg__lLhfM","color-dark":"RichTextContainer_color-dark__F3PL8","color-light":"RichTextContainer_color-light__eStiU","color-grey":"RichTextContainer_color-grey__KZw9N","color-brand":"RichTextContainer_color-brand__jF2dL"};

/***/ }),

/***/ 45930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"teacher":"TeacherLink_teacher__P45az","name":"TeacherLink_name__Ei042","tooltip":"TeacherLink_tooltip__9R4JZ","image":"TeacherLink_image___XYXB","title":"TeacherLink_title__dpx9D","description":"TeacherLink_description__PIPx5","arrow":"TeacherLink_arrow__Rf5Ee","link":"TeacherLink_link___fOae","icon":"TeacherLink_icon____sLw"};

/***/ }),

/***/ 82305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"teachers":"TeacherList_teachers__Yc_XT","teacher":"TeacherList_teacher__79iu1","timing":"TeacherList_timing__TBhan","title":"TeacherList_title__TLECi","description":"TeacherList_description__VpjFi","image":"TeacherList_image__ze0cu"};

/***/ }),

/***/ 40215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"InlineItems_list___1Esd","button":"InlineItems_button__NcR4Z","title":"InlineItems_title__5MVpd"};

/***/ }),

/***/ 44198:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InteractiveItems_wrapper__1kj5g","button":"InteractiveItems_button__cWLJ6","list":"InteractiveItems_list__iNv4m","icon":"InteractiveItems_icon__M1_75"};

/***/ }),

/***/ 79694:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatusPopup_wrapper__MATGM","blocks":"StatusPopup_blocks__JSa1u","title":"StatusPopup_title__QVWGn","circles":"StatusPopup_circles__dpL6R","circle":"StatusPopup_circle__lZ3rK","icon":"StatusPopup_icon__LvB9f","successful":"StatusPopup_successful__e0Gk9","error":"StatusPopup_error__9SaHM"};

/***/ }),

/***/ 64453:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccordionList_wrapper__6Th1g","list":"AccordionList_list__4Jhmn","list-item":"AccordionList_list-item__SCnil","description":"AccordionList_description__4VoRL","title":"AccordionList_title__HA33C","subtitle":"AccordionList_subtitle__b_ylv","bold":"AccordionList_bold__FXiqX","dropdown":"AccordionList_dropdown__wad3Y","icon":"AccordionList_icon__6wj5l","circle":"AccordionList_circle__UZjEq","opened":"AccordionList_opened__DvoQV"};

/***/ }),

/***/ 47688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Action_wrapper__D1Idv"};

/***/ }),

/***/ 89934:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"file":"AttachmentsList_file__sK66H"};

/***/ }),

/***/ 31667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Blockquote_wrapper__27Lm_","image":"Blockquote_image__aiNVg","text":"Blockquote_text__RIPKR","author":"Blockquote_author__iVM56","quote":"Blockquote_quote__XvuyG","person":"Blockquote_person__EpyJE"};

/***/ }),

/***/ 17756:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__Kob7H","outlined":"Button_outlined__smFrZ","no-text":"Button_no-text___AZaz","icon":"Button_icon__c680T","no-icon":"Button_no-icon__9KJDR","dark":"Button_dark__jB2dw","dark-reverse":"Button_dark-reverse__yf4FY","light":"Button_light__DEh1r","brand":"Button_brand__GBWCR","highlight":"Button_highlight__0hFWZ","reverse":"Button_reverse__KzYZT","fill":"Button_fill__PismZ","text":"Button_text__7hgK4"};

/***/ }),

/***/ 64949:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__KwFRe"};

/***/ }),

/***/ 23777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"details":"DetailsBlock_details__E_LM_","text":"DetailsBlock_text__j5pGX","label":"DetailsBlock_label__xiJv6"};

/***/ }),

/***/ 70686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"DownloadFile_icon__5sQ3X","download":"DownloadFile_download__t_EtA"};

/***/ }),

/***/ 25343:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"Icon_image__HTkWD","white":"Icon_white__s_fIV","grey":"Icon_grey__yGHWj","dark":"Icon_dark___qV4l","accent":"Icon_accent__79LTk"};

/***/ }),

/***/ 47805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"InputCheckbox_label__6r__T","checkmark":"InputCheckbox_checkmark__wbIhP","checkmark--required":"InputCheckbox_checkmark--required__QaDH3","checkbox":"InputCheckbox_checkbox__EfLHv"};

/***/ }),

/***/ 59901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input-type":"InputEmail_input-type__JXOqf","input":"InputEmail_input__7ZP9N","error":"InputEmail_error__EIONL","has-error":"InputEmail_has-error__ssa5y"};

/***/ }),

/***/ 59340:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input-type":"InputTel_input-type__J6HK9","input":"InputTel_input__YqvEA","error":"InputTel_error__c5Iiz","has-error":"InputTel_has-error__pmOMr","input-type--tel":"InputTel_input-type--tel__XBlnV"};

/***/ }),

/***/ 84370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input-type":"InputText_input-type__mi0X4","input":"InputText_input__YOv_v","error":"InputText_error__J4gmW","has-error":"InputText_has-error__k0Fh5"};

/***/ }),

/***/ 46507:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"more":"LazyRenderingButton_more__RNWCD","loader":"LazyRenderingButton_loader__A49Sj","loader-wrapper":"LazyRenderingButton_loader-wrapper__PbIP_","grey":"LazyRenderingButton_grey__0XUue"};

/***/ }),

/***/ 11241:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalWrapper_wrapper__bC4ZV","inner":"ModalWrapper_inner__vCctH","close":"ModalWrapper_close__LdPuv","close-icon":"ModalWrapper_close-icon__4QQhb","course-list":"ModalWrapper_course-list__yZg05","full-area":"ModalWrapper_full-area__YHlq3"};

/***/ }),

/***/ 80664:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article":"Article_article__PRWjr","text":"Article_text__11gYh","title":"Article_title___DQlK","media":"Article_media__RzNVH","image":"Article_image__LTVfX"};

/***/ }),

/***/ 406:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"Banner_block__5Yjwa","card":"Banner_card__eyUL8","text":"Banner_text__K_W8g","heading":"Banner_heading__sRq9f","description":"Banner_description__tNAKJ","button":"Banner_button__dMdyA","arrow":"Banner_arrow__NouIu","icon":"Banner_icon__u4yIb","date":"Banner_date__os4sk","more":"Banner_more__m9HZ9"};

/***/ }),

/***/ 84995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article":"HighlightedArticle_article__bcHlE","image":"HighlightedArticle_image__CsoCM","content":"HighlightedArticle_content__3OXES","card":"HighlightedArticle_card__qvhoJ","text":"HighlightedArticle_text__Acq_9","title":"HighlightedArticle_title__ihpVy","date":"HighlightedArticle_date__LnwHf","link":"HighlightedArticle_link__jjwyL","icon":"HighlightedArticle_icon__6OcwS","arrow":"HighlightedArticle_arrow__5DRnO"};

/***/ }),

/***/ 76658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderedList_wrapper__J0k9g","list":"OrderedList_list__3S6At","list-item":"OrderedList_list-item__S_WXH","description":"OrderedList_description__LnXHe","title":"OrderedList_title__TsQif","small":"OrderedList_small__94A4g","bigger":"OrderedList_bigger__KVqMX","bold":"OrderedList_bold__9aK5W"};

/***/ }),

/***/ 88959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"portal":"Portal_portal__PeCYj"};

/***/ }),

/***/ 81431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Poster_wrapper__ynk8O","inner":"Poster_inner__mdxZc","content":"Poster_content__mnYS4","image":"Poster_image__fQaSh","default":"Poster_default__XWBda","accent":"Poster_accent__yhbFu","title":"Poster_title__QPAVk"};

/***/ }),

/***/ 87737:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SiteLogo_wrapper__l8REt","image":"SiteLogo_image__WgdVk"};

/***/ }),

/***/ 95064:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sticky":"StickableContent_sticky__viwHx"};

/***/ }),

/***/ 88288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination-current":"SwiperLayout_pagination-current__Ub_3h"};

/***/ }),

/***/ 64283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tabs_wrapper__RsT27","tabs":"Tabs_tabs__MbfAq","tabs-list":"Tabs_tabs-list__HEyl_","tabs-item":"Tabs_tabs-item__aVjun","tabs-item-active":"Tabs_tabs-item-active__eEKap","underline":"Tabs_underline__pEn7_","tab-years":"Tabs_tab-years__blgGu","justify":"Tabs_justify__6qGcJ"};

/***/ }),

/***/ 46837:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Tags_title__RUxGZ","tags":"Tags_tags__peLrc","active":"Tags_active__OjkTx","link":"Tags_link__NQhVz","tag":"Tags_tag__9vxtS","button":"Tags_button__8cnBJ","arrow":"Tags_arrow__Pbjjx","label":"Tags_label__5B6Uj","icon":"Tags_icon__mvI3H","heading":"Tags_heading__LXOxi"};

/***/ }),

/***/ 59237:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading1_element___SY_R"};

/***/ }),

/***/ 22332:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading2_element__o_xqX"};

/***/ }),

/***/ 36529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading3_element__39_Rs"};

/***/ }),

/***/ 84979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading4_element__9MiU3"};

/***/ }),

/***/ 97275:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading5_element__kKP0X"};

/***/ }),

/***/ 29898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading6_element__wXPAY"};

/***/ }),

/***/ 33668:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading7_element__DPWRp"};

/***/ }),

/***/ 85025:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"element":"MenuItem_element__d6TVV"};

/***/ }),

/***/ 1732:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"element":"Paragraph_element__zFP1G","appearance-bold":"Paragraph_appearance-bold__N5zS7","appearance-bigger":"Paragraph_appearance-bigger__bCKrH","appearance-smaller":"Paragraph_appearance-smaller__pailB"};

/***/ }),

/***/ 7873:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"element":"Typography_element__TBYrL","uppercase":"Typography_uppercase__gTSnF","color-dark":"Typography_color-dark__m8MKN","color-light":"Typography_color-light__moGBi","color-grey":"Typography_color-grey__NDG0W","color-brand":"Typography_color-brand__On_1b","color-blue":"Typography_color-blue__lY89A"};

/***/ }),

/***/ 26731:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YoutubeVideo_wrapper__ypxEh","player":"YoutubeVideo_player__PIL8E"};

/***/ })

}]);